<template>
    <div>
        <Head title="我的購物車" />

        <div v-if="existing_delivery_types.length > 0">
            <div
                class="my-10"
                :key="delivery_type + '_delivery'"
                v-for="delivery_type in existing_delivery_types"
            >
                <div>
                    <!--
        selectionMode="multiple"
        :metaKeySelection="false"
        showGridlines
          -->
                    <DataTable
                        breakpoint="800px"
                        responsiveLayout="stack"
                        :loading="isLoading"
                        :ref="'datatable_' + delivery_type"
                        :value="
                            shopping_cart.products[delivery_type].filter(
                                (product) => product.type != 'add-on'
                            )
                        "
                        :selection.sync="
                            selected_products_by_type[delivery_type]
                        "
                        :expandedRows.sync="
                            expended_products_by_type[delivery_type]
                        "
                        @update:selection="
                            checkAvailability(delivery_type, $event)
                        "
                    >
                        <!-- @hook:mounted="selectAll(delivery_type)" -->

                        <template #header>
                            <div class="table-header">
                                {{ delivery_types[delivery_type] }}
                                <span
                                    v-if="windowWidth <= 800"
                                    class="absolute right-3 cursor-pointer"
                                    @click="selectType(delivery_type)"
                                >
                                    <template v-if="!allSelected[delivery_type]"
                                        >選擇全部</template
                                    ><template v-else>取消全選</template>
                                </span>
                            </div>
                        </template>

                        <Column headerClass="w-11" selectionMode="multiple">
                            <!-- <template #body="slotProps">{{ slotProps.rowData }}</template> -->
                        </Column>

                        <Column
                            :ref="delivery_type + '_product_column'"
                            header="商品"
                        >
                            <template #body="slotProps">
                                <div
                                    class="flex justify-start items-center gap-x-4 max-w-full cursor-zoom-in"
                                    @click="
                                        goToProductPage(slotProps.data.slug)
                                    "
                                >
                                    <!-- v-if="Array.isArray(slotProps.data.image) && slotProps.data.images.length > 0" -->
                                    <img
                                        v-if="
                                            Array.isArray(
                                                slotProps.data.images
                                            ) &&
                                            slotProps.data.images.length > 0
                                        "
                                        class="object-cover aspect-square product-image"
                                        :src="
                                            '/storage/product-images/' +
                                            slotProps.data.images[0] +
                                            '/100.jpg'
                                        "
                                    />
                                    <img
                                        v-else
                                        class="object-cover aspect-square product-image"
                                        src="//dummyimage.com/100/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                                    />
                                    <div
                                        class="flex flex-col justify-start items-start gap-y-1"
                                    >
                                        <!-- {{ slotProps.data.id }} {{ slotProps.data.name }} -->
                                        {{ slotProps.data.name }}
                                        <div
                                            class="text-red"
                                            v-if="
                                                slotProps.data.settings
                                                    .time_limit &&
                                                !dayjs().isBetween(
                                                    slotProps.data.settings
                                                        .duration.start,
                                                    slotProps.data.settings
                                                        .duration.end,
                                                    '[)'
                                                )
                                            "
                                        >
                                            非開放銷售時間
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Column>

                        <Column headerClass="w-40" header="價格">
                            <template #body="slotProps">
                                <div
                                    class="flex flex-col justify-start items-start gap-y-1"
                                >
                                    <div>
                                        <span
                                            :class="{
                                                'line-through':
                                                    slotProps.data.settings
                                                        .on_sale,
                                            }"
                                            >{{
                                                slotProps.data.settings.discount
                                                    .original_price
                                                    | commaFormat
                                                    | priceFormat
                                            }}</span
                                        >
                                        <span
                                            v-if="
                                                slotProps.data.settings.on_sale
                                            "
                                            class="text-red ml-1"
                                            >{{
                                                slotProps.data.unit_price
                                                    | commaFormat
                                                    | priceFormat
                                            }}</span
                                        >
                                    </div>
                                    <div>
                                        CV:
                                        <span
                                            :class="{
                                                'line-through':
                                                    slotProps.data.settings
                                                        .on_sale,
                                            }"
                                            >{{
                                                slotProps.data.settings.discount
                                                    .original_cv | commaFormat
                                            }}</span
                                        >
                                        <span
                                            v-if="
                                                slotProps.data.settings.on_sale
                                            "
                                            class="text-red ml-1"
                                            >{{
                                                slotProps.data.unit_cv
                                                    | commaFormat
                                            }}</span
                                        >
                                    </div>
                                </div>
                            </template>
                        </Column>

                        <Column headerClass="w-20" header="數量">
                            <template #body="slotProps">
                                <div
                                    class="flex flex-col justify-between items-center"
                                >
                                    <div>
                                        <InputNumber
                                            ref="InputNumber"
                                            v-model="slotProps.data.quantity"
                                            showButtons
                                            suffix="個"
                                            buttonLayout="horizontal"
                                            decrementButtonClass="shopping-cart-decrease_button"
                                            incrementButtonClass="shopping-cart-increase_button"
                                            incrementButtonIcon="pi pi-plus"
                                            decrementButtonIcon="pi pi-minus"
                                            inputClass="shopping-cart-number_input"
                                            class="p-invalid"
                                            @input="
                                                handleInputQuantityChange(
                                                    slotProps.data
                                                )
                                            "
                                            @focus="
                                                setUpdateShoppingCartValue(
                                                    slotProps.data
                                                )
                                            "
                                            @blur="
                                                updateShoppingCart(
                                                    slotProps.data
                                                )
                                            "
                                            :disabled="
                                                slotProps.data.in_stock ==
                                                    -99999 ||
                                                slotProps.data.in_stock == 0
                                            "
                                        />
                                    </div>
                                    <div class="text-sm text-red text-center">
                                        <template
                                            v-if="
                                                slotProps.data.in_stock ==
                                                -99999
                                            "
                                        >
                                            商品無法購買
                                        </template>
                                        <template
                                            v-else-if="
                                                slotProps.data.in_stock <
                                                    slotProps.data.desired ||
                                                slotProps.data.in_stock <
                                                    slotProps.data.quantity
                                            "
                                        >
                                            庫存數量不足{{
                                                slotProps.data.desired
                                            }}個
                                        </template>
                                        <template
                                            v-else-if="
                                                slotProps.data.quantity < 1
                                            "
                                        >
                                            商品已售完
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </Column>

                        <Column headerClass="w-40" header="總計">
                            <template #body="slotProps">
                                <div
                                    class="flex flex-col justify-start items-start gap-y-1"
                                >
                                    <div
                                        :class="{
                                            'text-red':
                                                slotProps.data.settings.on_sale,
                                        }"
                                    >
                                        {{
                                            (slotProps.data.unit_price *
                                                slotProps.data.quantity)
                                                | commaFormat
                                                | priceFormat
                                        }}
                                    </div>
                                    <div
                                        :class="{
                                            'text-red':
                                                slotProps.data.settings.on_sale,
                                        }"
                                    >
                                        CV:
                                        {{
                                            (slotProps.data.unit_cv *
                                                slotProps.data.quantity)
                                                | commaFormat
                                        }}
                                    </div>
                                </div>
                            </template>
                        </Column>

                        <Column headerClass="w-11">
                            <template #body="slotProps">
                                <Button
                                    class="shopping-cart-trash_button"
                                    icon="pi pi-trash"
                                    @click="
                                        removeFromShoppingCart(slotProps.data)
                                    "
                            /></template>
                        </Column>

                        <template #expansion="slotProps">
                            <template v-if="slotProps.data.type == 'pack'">
                                <DataTable
                                    class="md:ml-10 md:w-1/2 border-l-4 border-l-fh-gray-light"
                                    :value="slotProps.data.includes_data"
                                >
                                    <Column header="包含商品">
                                        <template #body="slotProps">
                                            <div
                                                v-if="slotProps.data.available"
                                                class="flex justify-start items-center gap-x-4 max-w-full cursor-zoom-in"
                                                @click="
                                                    goToProductPage(
                                                        slotProps.data.slug
                                                    )
                                                "
                                            >
                                                <!-- v-if="Array.isArray(slotProps.data.image) && slotProps.data.images.length > 0" -->
                                                <img
                                                    v-if="
                                                        Array.isArray(
                                                            slotProps.data
                                                                .images
                                                        ) &&
                                                        slotProps.data.images
                                                            .length > 0
                                                    "
                                                    class="object-cover aspect-square product-image"
                                                    :src="
                                                        '/storage/product-images/' +
                                                        slotProps.data
                                                            .images[0] +
                                                        '/50.jpg'
                                                    "
                                                />
                                                <img
                                                    v-else
                                                    class="object-cover aspect-square product-image"
                                                    src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                                                />
                                                <div
                                                    :class="{
                                                        'line-through':
                                                            !slotProps.data
                                                                .available ||
                                                            (slotProps.data
                                                                .settings
                                                                .time_limit &&
                                                                !dayjs().isBetween(
                                                                    slotProps
                                                                        .data
                                                                        .settings
                                                                        .duration
                                                                        .start,
                                                                    slotProps
                                                                        .data
                                                                        .settings
                                                                        .duration
                                                                        .end,
                                                                    '[)'
                                                                )),
                                                        'text-red':
                                                            !slotProps.data
                                                                .available ||
                                                            (slotProps.data
                                                                .settings
                                                                .time_limit &&
                                                                !dayjs().isBetween(
                                                                    slotProps
                                                                        .data
                                                                        .settings
                                                                        .duration
                                                                        .start,
                                                                    slotProps
                                                                        .data
                                                                        .settings
                                                                        .duration
                                                                        .end,
                                                                    '[)'
                                                                )),
                                                    }"
                                                >
                                                    <!-- {{ slotProps.data.id }} {{ slotProps.data.name }} -->
                                                    {{ slotProps.data.name }}
                                                </div>
                                            </div>
                                            <div
                                                v-else
                                                class="flex justify-start items-center gap-x-4 max-w-full"
                                            >
                                                <img
                                                    v-if="
                                                        Array.isArray(
                                                            slotProps.data
                                                                .images
                                                        ) &&
                                                        slotProps.data.images
                                                            .length > 0
                                                    "
                                                    class="object-cover aspect-square product-image"
                                                    :src="
                                                        '/storage/product-images/' +
                                                        slotProps.data
                                                            .images[0] +
                                                        '/50.jpg'
                                                    "
                                                />
                                                <img
                                                    v-else
                                                    class="object-cover aspect-square product-image"
                                                    src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                                                />
                                                <div
                                                    class="line-through text-red"
                                                >
                                                    <!-- {{ slotProps.data.id }} {{ slotProps.data.name }} -->
                                                    {{ slotProps.data.name }}
                                                </div>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column field="quantity" header="數量">
                                        <template #body="slotProps">
                                            <span
                                                :class="{
                                                    'line-through':
                                                        !slotProps.data
                                                            .available ||
                                                        (slotProps.data.settings
                                                            .time_limit &&
                                                            !dayjs().isBetween(
                                                                slotProps.data
                                                                    .settings
                                                                    .duration
                                                                    .start,
                                                                slotProps.data
                                                                    .settings
                                                                    .duration
                                                                    .end,
                                                                '[)'
                                                            )),
                                                    'text-red':
                                                        !slotProps.data
                                                            .available ||
                                                        (slotProps.data.settings
                                                            .time_limit &&
                                                            !dayjs().isBetween(
                                                                slotProps.data
                                                                    .settings
                                                                    .duration
                                                                    .start,
                                                                slotProps.data
                                                                    .settings
                                                                    .duration
                                                                    .end,
                                                                '[)'
                                                            )),
                                                }"
                                                >{{
                                                    slotProps.data.quantity
                                                }}</span
                                            >
                                        </template>
                                    </Column>
                                </DataTable>
                                <!-- <div
                  :key="'pack_' + slotProps.data.id + '_' + merchandise.slug"
                  v-for="merchandise in slotProps.data.includes_data"
                >
                  {{ merchandise }}
                </div> -->
                            </template>
                        </template>

                        <template #footer>
                            <div
                                class="mt-0 mb-3"
                                v-if="
                                    hasAddOn(
                                        shopping_cart.products[delivery_type]
                                    )
                                "
                            >
                                <DataTable
                                    breakpoint="800px"
                                    responsiveLayout="stack"
                                    :value="
                                        shopping_cart.products[
                                            delivery_type
                                        ].filter(
                                            (product) =>
                                                product.type == 'add-on'
                                        )
                                    "
                                >
                                    <Column headerClass="w-11">
                                        <template #body="slotProps">
                                            <div
                                                v-if="
                                                    slotProps.data.type ==
                                                    'add-on'
                                                "
                                            >
                                                加購
                                            </div>
                                        </template>
                                    </Column>
                                    <Column
                                        ><template #body="slotProps">
                                            <div
                                                class="flex justify-start items-center gap-x-4 cursor-zoom-in"
                                            >
                                                <!-- @click="goToProductPage(slotProps.data.slug)" -->
                                                <img
                                                    v-if="
                                                        Array.isArray(
                                                            slotProps.data
                                                                .images
                                                        ) &&
                                                        slotProps.data.images
                                                            .length > 0
                                                    "
                                                    class="object-cover aspect-square product-image"
                                                    :src="
                                                        '/storage/product-images/' +
                                                        slotProps.data
                                                            .images[0] +
                                                        '/100.jpg'
                                                    "
                                                />
                                                <img
                                                    v-else
                                                    class="object-cover aspect-square product-image"
                                                    src="//dummyimage.com/100/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                                                />
                                                <div
                                                    class="flex flex-col justify-start items-start gap-y-1"
                                                >
                                                    <!-- {{ slotProps.data.id }} {{ slotProps.data.name }} -->
                                                    {{ slotProps.data.name }}
                                                    <div
                                                        class="text-red"
                                                        v-if="
                                                            slotProps.data
                                                                .settings
                                                                .time_limit &&
                                                            !dayjs().isBetween(
                                                                slotProps.data
                                                                    .settings
                                                                    .duration
                                                                    .start,
                                                                slotProps.data
                                                                    .settings
                                                                    .duration
                                                                    .end,
                                                                '[)'
                                                            )
                                                        "
                                                    >
                                                        非開放銷售時間
                                                    </div>
                                                </div>
                                            </div>
                                        </template></Column
                                    >
                                    <Column headerClass="w-40"
                                        ><template #body="slotProps">
                                            <div
                                                class="flex flex-col justify-start items-start gap-y-1"
                                            >
                                                <div>
                                                    {{
                                                        slotProps.data
                                                            .unit_price
                                                            | commaFormat
                                                            | priceFormat
                                                    }}
                                                </div>
                                                <div>
                                                    CV:
                                                    {{
                                                        slotProps.data.unit_cv
                                                            | commaFormat
                                                    }}
                                                </div>
                                            </div>
                                        </template></Column
                                    >
                                    <Column headerClass="w-20"
                                        ><template #body="slotProps">
                                            <div
                                                class="flex flex-col justify-between items-center"
                                            >
                                                <div>
                                                    <InputNumber
                                                        ref="InputNumber"
                                                        v-model="
                                                            slotProps.data
                                                                .quantity
                                                        "
                                                        showButtons
                                                        suffix="個"
                                                        buttonLayout="horizontal"
                                                        decrementButtonClass="shopping-cart-decrease_button"
                                                        incrementButtonClass="shopping-cart-increase_button"
                                                        incrementButtonIcon="pi pi-plus"
                                                        decrementButtonIcon="pi
                    pi-minus"
                                                        inputClass="shopping-cart-number_input"
                                                        class="p-invalid"
                                                        @input="
                                                            handleInputQuantityChange(
                                                                slotProps.data
                                                            )
                                                        "
                                                        @blur="
                                                            updateShoppingCart
                                                        "
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                class="text-sm text-red text-center"
                                            >
                                                <template
                                                    v-if="
                                                        slotProps.data
                                                            .in_stock == -99999
                                                    "
                                                >
                                                    商品無法購買
                                                </template>
                                                <template
                                                    v-else-if="
                                                        slotProps.data
                                                            .in_stock <
                                                            slotProps.data
                                                                .desired ||
                                                        slotProps.data
                                                            .in_stock <
                                                            slotProps.data
                                                                .quantity
                                                    "
                                                >
                                                    庫存數量不足{{
                                                        slotProps.data.desired
                                                    }}個
                                                </template>
                                                <template
                                                    v-else-if="
                                                        slotProps.data
                                                            .quantity < 1
                                                    "
                                                >
                                                    商品已售完
                                                </template>
                                            </div>
                                        </template></Column
                                    >
                                    <Column headerClass="w-40"
                                        ><template #body="slotProps">
                                            <div
                                                class="flex flex-col justify-start items-start gap-y-1"
                                            >
                                                <div>
                                                    {{
                                                        (slotProps.data
                                                            .unit_price *
                                                            slotProps.data
                                                                .quantity)
                                                            | commaFormat
                                                            | priceFormat
                                                    }}
                                                </div>
                                                <div>
                                                    CV:
                                                    {{
                                                        (slotProps.data
                                                            .unit_cv *
                                                            slotProps.data
                                                                .quantity)
                                                            | commaFormat
                                                    }}
                                                </div>
                                            </div>
                                        </template></Column
                                    >
                                    <Column headerClass="w-11"
                                        ><template #body="slotProps"
                                            ><Button
                                                class="shopping-cart-trash_button"
                                                icon="pi pi-trash"
                                                @click="
                                                    removeFromShoppingCart(
                                                        slotProps.data
                                                    )
                                                " /></template
                                    ></Column>
                                </DataTable>
                            </div>
                            <div class="flex justify-between items-center px-6">
                                <div>
                                    <span>
                                        已選
                                        {{
                                            selected_products_by_type[
                                                delivery_type
                                            ]
                                                ? selected_products_by_type[
                                                      delivery_type
                                                  ].length
                                                : 0
                                        }}
                                        個商品，共有
                                        {{
                                            shopping_cart.products[
                                                delivery_type
                                            ]
                                                ? shopping_cart.products[
                                                      delivery_type
                                                  ].filter(
                                                      (product) =>
                                                          product.type !=
                                                          "add-on"
                                                  ).length
                                                : 0
                                        }}
                                        個商品。
                                    </span>
                                </div>
                                <div
                                    class="flex justify-end items-center gap-16"
                                >
                                    <span
                                        class="text-red"
                                        v-if="
                                            selected_products_by_type[
                                                delivery_type
                                            ].length &&
                                            matchFreeShipping(delivery_type)
                                        "
                                    >
                                        {{ matchFreeShipping(delivery_type) }}
                                    </span>
                                    <span
                                        >運費
                                        {{
                                            sum("delivery_fee", delivery_type)
                                                | commaFormat
                                                | priceFormat
                                        }}
                                        <template
                                            v-if="
                                                selected_products_by_type[
                                                    delivery_type
                                                ].length &&
                                                need_extra_delivery_fee &&
                                                !matchFreeShipping(
                                                    delivery_type
                                                )
                                            "
                                        >
                                            <span class="text-red"
                                                >（含離島地區處理費）</span
                                            >
                                        </template>
                                    </span>
                                    <span
                                        >總計
                                        {{
                                            sum("total_price", delivery_type)
                                                | commaFormat
                                                | priceFormat
                                        }}
                                    </span>
                                    <span
                                        >CV
                                        {{
                                            sum("total_cv", delivery_type)
                                                | commaFormat
                                        }}</span
                                    >
                                </div>
                            </div>
                        </template>
                    </DataTable>
                    <div
                        v-if="
                            !hasAddOn(shopping_cart.products[delivery_type]) &&
                            $page.props.add_ons[delivery_type].length > 0
                        "
                    >
                        <Carousel
                            :data-set="$page.props.add_ons[delivery_type]"
                            :sizes="[10, 6, 3, 2]"
                            :show-quantity-input="false"
                            price-tag="horizontal"
                            product-max-width="100px"
                            >加購 {{ delivery_types[delivery_type] }}</Carousel
                        >
                    </div>
                </div>
            </div>
            <div class="text-center my-20">
                <div v-if="!$page.props.auth.user">
                    <div class="my-10 text-fh-blue">
                        <h1 class="text-xl mb-2 text-black">
                            準備好要結帳了嗎？
                        </h1>
                        請先
                        <Link
                            class="text-black"
                            :href="route('login') + '?from=shopping_cart'"
                            as="button"
                            >登入</Link
                        >
                        後再進行結帳，以享有您的購物回饋。
                    </div>
                    <div class="my-10 text-fh-blue">
                        <h1 class="text-xl mb-2 text-black">
                            不是我們的會員嗎？
                        </h1>
                        結帳之前，您可以先
                        <Link
                            class="text-black"
                            :href="route('register') + '?from=shopping_cart'"
                            as="button"
                            >註冊</Link
                        >
                        成為我們的會員，讓您享有滿滿的好康回饋！
                    </div>
                </div>

                <div v-if="$page.props.auth.user">
                    <!-- 已登入 -->
                    <div
                        class="mt-20 w-full flex justify-around"
                        :class="flex_direction"
                    >
                        <div
                            :class="{
                                'w-1/2': flex_direction == 'flex-row',
                                'w-full': flex_direction == 'flex-col',
                            }"
                        >
                            <div class="px-2 py-2" ref="pay_info">
                                <Fieldset>
                                    <template #legend>付款資訊 </template>
                                    <div class="my-4">
                                        <RadioButton
                                            id="purchase_as_contact"
                                            name="purchaser"
                                            value="as_contact"
                                            v-model="formData.purchaser"
                                        />
                                        <label for="purchase_as_contact"
                                            >同會員資料</label
                                        >
                                        <transition name="p-toggleable-content">
                                            <div
                                                v-if="
                                                    formData.purchaser ==
                                                    'as_contact'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div class="my-1">
                                                    姓名：{{
                                                        $page.props.auth.user
                                                            .name
                                                    }}
                                                </div>
                                                <div class="my-1">
                                                    連絡電話：{{
                                                        $page.props.auth.user
                                                            .mobile ??
                                                        $page.props.auth.user
                                                            .tel
                                                    }}
                                                </div>
                                                <div class="my-1">
                                                    電子郵件：{{
                                                        $page.props.auth.user
                                                            .email
                                                    }}
                                                </div>
                                                <div
                                                    v-if="
                                                        $page.props.auth.user
                                                            .shipping_info &&
                                                        $page.props.auth.user
                                                            .shipping_info
                                                            ?.district?.zip &&
                                                        $page.props.auth.user
                                                            .shipping_info
                                                            ?.city &&
                                                        $page.props.auth.user
                                                            .shipping_info
                                                            ?.district?.name &&
                                                        $page.props.auth.user
                                                            .shipping_info
                                                            ?.address
                                                    "
                                                    class="my-1"
                                                >
                                                    地址：{{
                                                        $page.props.auth.user
                                                            .shipping_info
                                                            ?.district?.zip
                                                    }}
                                                    {{
                                                        $page.props.auth.user
                                                            .shipping_info
                                                            ?.city +
                                                        $page.props.auth.user
                                                            .shipping_info
                                                            ?.district?.name +
                                                        $page.props.auth.user
                                                            .shipping_info
                                                            ?.address
                                                    }}
                                                </div>
                                                <div v-else>
                                                    地址：（無資料）
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                    <div class="my-4">
                                        <RadioButton
                                            id="purchase_new"
                                            name="purchaser"
                                            value="new"
                                            v-model="formData.purchaser"
                                        />
                                        <label for="purchase_new"
                                            >自行填寫</label
                                        >
                                        <transition name="p-toggleable-content">
                                            <div
                                                v-if="
                                                    formData.purchaser == 'new'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div class="my-1">
                                                    <div
                                                        class="shopping_cart_form_element"
                                                    >
                                                        <div class="label">
                                                            <label
                                                                for="purchaser_name"
                                                                >姓名</label
                                                            >
                                                        </div>
                                                        <div class="input">
                                                            <InputText
                                                                id="purchaser_name"
                                                                v-model="
                                                                    formData
                                                                        .purchaser_new
                                                                        .name
                                                                "
                                                                type="text"
                                                                :class="{
                                                                    'p-invalid':
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.purchaser.name'
                                                                        ],
                                                                }"
                                                            />
                                                            <div
                                                                v-if="
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.name'
                                                                    ]
                                                                "
                                                                class="error_information"
                                                            >
                                                                <i
                                                                    class="pi pi-arrow-up"
                                                                />
                                                                {{
                                                                    $page.props
                                                                        .errors[
                                                                        "payload.purchaser.name"
                                                                    ]
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="my-1">
                                                    <div
                                                        class="shopping_cart_form_element"
                                                    >
                                                        <div class="label">
                                                            <label
                                                                for="purchaser_phone"
                                                                >連絡電話</label
                                                            >
                                                        </div>
                                                        <div class="input">
                                                            <InputText
                                                                id="purchaser_phone"
                                                                v-model="
                                                                    formData
                                                                        .purchaser_new
                                                                        .phone
                                                                "
                                                                placeholder="市話請加上區域碼"
                                                                :class="{
                                                                    'p-invalid':
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.purchaser.phone'
                                                                        ],
                                                                }"
                                                            />
                                                            <div
                                                                v-if="
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.phone'
                                                                    ]
                                                                "
                                                                class="error_information"
                                                            >
                                                                <i
                                                                    class="pi pi-arrow-up"
                                                                />
                                                                {{
                                                                    $page.props
                                                                        .errors[
                                                                        "payload.purchaser.phone"
                                                                    ]
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="my-1">
                                                    <div
                                                        class="shopping_cart_form_element"
                                                    >
                                                        <div class="label">
                                                            <label
                                                                for="purchaser_email"
                                                                >電子郵件</label
                                                            >
                                                        </div>
                                                        <div class="input">
                                                            <InputText
                                                                id="purchaser_phone"
                                                                v-model="
                                                                    formData
                                                                        .purchaser_new
                                                                        .email
                                                                "
                                                                :class="{
                                                                    'p-invalid':
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.purchaser.email'
                                                                        ],
                                                                }"
                                                            />
                                                            <div
                                                                v-if="
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.email'
                                                                    ]
                                                                "
                                                                class="error_information"
                                                            >
                                                                <i
                                                                    class="pi pi-arrow-up"
                                                                />
                                                                {{
                                                                    $page.props
                                                                        .errors[
                                                                        "payload.purchaser.email"
                                                                    ]
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="my-1">
                                                    <div
                                                        class="shopping_cart_form_element"
                                                    >
                                                        <div class="label">
                                                            <label
                                                                for="purchaser_address"
                                                                >地址</label
                                                            >
                                                        </div>
                                                        <div class="input">
                                                            <Dropdown
                                                                id="purchaser_address"
                                                                class="w-32"
                                                                v-model="
                                                                    formData
                                                                        .purchaser_new
                                                                        .city
                                                                "
                                                                :options="
                                                                    taiwan_districts
                                                                "
                                                                optionLabel="name"
                                                                placeholder="縣市"
                                                                :class="{
                                                                    'p-invalid':
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.purchaser.address'
                                                                        ],
                                                                }"
                                                                :filter="true"
                                                                filterPlaceholder="尋找"
                                                                emptyFilterMessage="沒有符合的結果"
                                                                @change="
                                                                    formData.purchaser_new.district =
                                                                        null
                                                                "
                                                            />
                                                            <Dropdown
                                                                id="district"
                                                                class="w-36"
                                                                v-model="
                                                                    formData
                                                                        .purchaser_new
                                                                        .district
                                                                "
                                                                :options="
                                                                    selected_city_purchaser_new_districts
                                                                "
                                                                optionLabel="name"
                                                                placeholder="行政區"
                                                                :class="{
                                                                    'p-invalid':
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.purchaser.address'
                                                                        ],
                                                                }"
                                                                :filter="true"
                                                                filterPlaceholder="尋找"
                                                                emptyFilterMessage="沒有符合的結果"
                                                                :disabled="
                                                                    !formData
                                                                        .purchaser_new
                                                                        .city
                                                                "
                                                            />
                                                            <InputText
                                                                v-model="
                                                                    formData
                                                                        .purchaser_new
                                                                        .address
                                                                "
                                                                class="w-64"
                                                                type="text"
                                                                placeholder="路名及門牌號碼"
                                                                :class="{
                                                                    'p-invalid':
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.purchaser.address'
                                                                        ],
                                                                }"
                                                                :disabled="
                                                                    !formData
                                                                        .purchaser_new
                                                                        .district
                                                                "
                                                            />
                                                            <div
                                                                v-if="
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.address'
                                                                    ]
                                                                "
                                                                class="error_information"
                                                            >
                                                                <i
                                                                    class="pi pi-arrow-up"
                                                                />
                                                                {{
                                                                    $page.props
                                                                        .errors[
                                                                        "payload.purchaser.address"
                                                                    ]
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                </Fieldset>
                            </div>
                            <div class="px-2 py-2">
                                <Fieldset>
                                    <template #legend>寄送方式</template>
                                    <div class="my-4">
                                        <RadioButton
                                            id="delivery_method_regular"
                                            name="delivery_method"
                                            value="regular"
                                            v-model="formData.delivery_method"
                                        />
                                        <label for="delivery_method_regular"
                                            >一般物流</label
                                        >
                                        <transition name="p-toggleable-content">
                                            <div
                                                v-if="
                                                    formData.delivery_method ==
                                                    'regular'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div
                                                    class="shopping_cart_form_element"
                                                >
                                                    <div class="label">
                                                        <label>到貨時間</label>
                                                    </div>
                                                    <div class="input">
                                                        <SelectButton
                                                            v-model="
                                                                formData.delivery_time
                                                            "
                                                            :options="[
                                                                '上午',
                                                                '下午',
                                                                '全日',
                                                            ]"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                    <div class="my-4">
                                        <RadioButton
                                            id="delivery_method_711"
                                            name="delivery_method"
                                            value="711"
                                            v-model="formData.delivery_method"
                                            :disabled="
                                                this
                                                    .SelectedRefrigeratedProducts
                                                    .length > 0
                                            "
                                        />
                                        <label for="delivery_method_711"
                                            >統一超商店到店 免付款取貨</label
                                        >
                                        <transition name="p-toggleable-content">
                                            <div
                                                v-if="
                                                    formData.delivery_method ==
                                                    '711'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div
                                                    v-if="formData.presco_store"
                                                >
                                                    <div class="my-1">
                                                        門市名稱：{{
                                                            formData
                                                                .presco_store
                                                                .storename
                                                        }}
                                                    </div>
                                                    <div class="my-1">
                                                        門市地址：{{
                                                            formData
                                                                .presco_store
                                                                .storeaddress
                                                        }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="shopping_cart_form_element"
                                                >
                                                    <Button
                                                        :label="
                                                            formData.presco_store
                                                                ? '更改收件門市'
                                                                : '選擇收件門市'
                                                        "
                                                        @click="
                                                            showPrescoStoreSelection
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    class="shopping_cart_form_element_no_border text-sm my-2 text-red"
                                                    v-if="
                                                        this
                                                            .SelectedFrozenProducts
                                                            .length > 0
                                                    "
                                                >
                                                    因結帳的商品中包含冷凍商品，故僅能選擇可配送冷凍溫層之門市。<br />如需選擇其他門市請將冷凍溫層分開結帳。
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                    <div class="my-4">
                                        <RadioButton
                                            id="delivery_method_711_pay"
                                            name="delivery_method"
                                            value="711_pay"
                                            v-model="formData.delivery_method"
                                            :disabled="
                                                this
                                                    .SelectedRefrigeratedProducts
                                                    .length > 0
                                            "
                                        />
                                        <label for="delivery_method_711_pay"
                                            >統一超商店到店 貨到付款</label
                                        >
                                        <transition name="p-toggleable-content">
                                            <div
                                                v-if="
                                                    formData.delivery_method ==
                                                    '711_pay'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div
                                                    v-if="
                                                        formData.presco_store_pay
                                                    "
                                                >
                                                    <div class="my-1">
                                                        門市名稱：{{
                                                            formData
                                                                .presco_store_pay
                                                                .storename
                                                        }}
                                                    </div>
                                                    <div class="my-1">
                                                        門市地址：{{
                                                            formData
                                                                .presco_store_pay
                                                                .storeaddress
                                                        }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="shopping_cart_form_element"
                                                >
                                                    <Button
                                                        :label="
                                                            formData.presco_store_pay
                                                                ? '更改收件門市'
                                                                : '選擇收件門市'
                                                        "
                                                        @click="
                                                            showPrescoStoreSelection
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    class="shopping_cart_form_element_no_border text-sm my-2 text-red"
                                                    v-if="
                                                        this
                                                            .SelectedFrozenProducts
                                                            .length > 0
                                                    "
                                                >
                                                    因結帳的商品中包含冷凍商品，故僅能選擇可配送冷凍溫層之門市。<br />如需選擇其他門市請將冷凍溫層分開結帳。
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                    <div
                                        class="my-4 text-sm text-red"
                                        v-if="
                                            this.SelectedRefrigeratedProducts
                                                .length > 0
                                        "
                                    >
                                        因結帳的商品中包含冷藏商品，故無法選擇統一超商店到店作為寄送方式。<br />如需選擇此寄送方式請將冷藏溫層分開結帳。
                                    </div>
                                </Fieldset>
                            </div>
                            <div class="px-2 py-2">
                                <Fieldset>
                                    <template #legend>收貨資訊</template>
                                    <!-- 一般物流 -->
                                    <template
                                        v-if="
                                            formData.delivery_method ==
                                            'regular'
                                        "
                                    >
                                        <div class="my-4">
                                            <RadioButton
                                                id="delivery_as_purchaser"
                                                name="delivery"
                                                value="as_purchaser"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_as_purchaser"
                                                >同付款資料</label
                                            >
                                        </div>
                                        <div class="my-4">
                                            <RadioButton
                                                id="delivery_as_contact"
                                                name="delivery"
                                                value="as_contact"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_as_contact"
                                                >同會員資料</label
                                            >
                                            <transition
                                                name="p-toggleable-content"
                                            >
                                                <div
                                                    v-if="
                                                        formData.delivery ==
                                                            'as_contact' &&
                                                        formData.purchaser !=
                                                            'as_contact'
                                                    "
                                                    class="mt-2 ml-2"
                                                >
                                                    <div class="my-1">
                                                        收件人：{{
                                                            $page.props.auth
                                                                .user.name
                                                        }}
                                                    </div>
                                                    <div class="my-1">
                                                        連絡電話：{{
                                                            $page.props.auth
                                                                .user.mobile ??
                                                            $page.props.auth
                                                                .user.tel
                                                        }}
                                                    </div>
                                                    <div
                                                        class="my-1"
                                                        v-if="
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info &&
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info
                                                                ?.district
                                                                ?.zip &&
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info
                                                                ?.city &&
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info
                                                                ?.district
                                                                ?.name &&
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info
                                                                ?.address
                                                        "
                                                    >
                                                        地址：{{
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info
                                                                ?.district?.zip
                                                        }}
                                                        {{
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info
                                                                ?.city +
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info
                                                                ?.district
                                                                ?.name +
                                                            $page.props.auth
                                                                .user
                                                                .shipping_info
                                                                ?.address
                                                        }}
                                                    </div>
                                                    <div v-else>
                                                        地址：（無資料）
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="my-4">
                                            <RadioButton
                                                id="delivery_address_book"
                                                name="delivery"
                                                value="address_book"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_address_book"
                                                >其他常用收件人</label
                                            >
                                            <div
                                                v-if="
                                                    formData.delivery ==
                                                    'address_book'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div
                                                    v-if="
                                                        $page.props.auth.user
                                                            .preferences
                                                            ?.address_book
                                                    "
                                                >
                                                    <div
                                                        :key="
                                                            contact.name +
                                                            '_' +
                                                            contact.phone +
                                                            '_' +
                                                            contact.email +
                                                            '_' +
                                                            contact
                                                                .shipping_info
                                                                ?.address
                                                        "
                                                        v-for="(
                                                            contact, index
                                                        ) in $page.props.auth
                                                            .user.preferences
                                                            ?.address_book"
                                                    >
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div>
                                                                <RadioButton
                                                                    :id="
                                                                        'delivery_address_book_' +
                                                                        index
                                                                    "
                                                                    name="contact"
                                                                    :value="
                                                                        contact
                                                                    "
                                                                    v-model="
                                                                        formData.delivery_old
                                                                    "
                                                                />
                                                            </div>
                                                            <div class="ml-2">
                                                                <div>
                                                                    <label
                                                                        :for="
                                                                            'delivery_address_book_' +
                                                                            index
                                                                        "
                                                                    >
                                                                        收件人：{{
                                                                            contact.name
                                                                        }}
                                                                    </label>
                                                                </div>
                                                                <div>
                                                                    <label
                                                                        :for="
                                                                            'delivery_address_book_' +
                                                                            index
                                                                        "
                                                                    >
                                                                        連絡電話：{{
                                                                            contact.phone
                                                                        }}
                                                                    </label>
                                                                </div>
                                                                <div>
                                                                    <label
                                                                        :for="
                                                                            'delivery_address_book_' +
                                                                            index
                                                                        "
                                                                    >
                                                                        地址：
                                                                        {{
                                                                            contact
                                                                                .shipping_info
                                                                                ?.city
                                                                        }}{{
                                                                            contact
                                                                                .shipping_info
                                                                                ?.district
                                                                                ?.name
                                                                        }}{{
                                                                            contact
                                                                                .shipping_info
                                                                                ?.address
                                                                        }}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    沒有儲存的常用聯絡人
                                                </div>
                                            </div>
                                        </div>
                                        <div class="my-2">
                                            <RadioButton
                                                id="delivery_new"
                                                name="delivery"
                                                value="new"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_new"
                                                >自行填寫</label
                                            >
                                            <transition
                                                name="p-toggleable-content"
                                            >
                                                <div
                                                    v-if="
                                                        formData.delivery ==
                                                        'new'
                                                    "
                                                    class="mt-2 ml-2"
                                                >
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_name"
                                                                    >姓名</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <InputText
                                                                    id="delivery_name"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .name
                                                                    "
                                                                    type="text"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.name'
                                                                            ],
                                                                    }"
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.name'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.name"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_phone"
                                                                    >連絡電話</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <InputText
                                                                    id="delivery_phone"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .phone
                                                                    "
                                                                    placeholder="市話請加上區域碼"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.phone'
                                                                            ],
                                                                    }"
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.phone'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.phone"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_address"
                                                                    >地址</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <Dropdown
                                                                    id="delivery_address"
                                                                    class="w-32"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .city
                                                                    "
                                                                    :options="
                                                                        taiwan_districts
                                                                    "
                                                                    optionLabel="name"
                                                                    placeholder="縣市"
                                                                    :filter="
                                                                        true
                                                                    "
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.address'
                                                                            ],
                                                                    }"
                                                                    filterPlaceholder="尋找"
                                                                    emptyFilterMessage="沒有符合的結果"
                                                                    @change="
                                                                        formData.delivery_new.district =
                                                                            null
                                                                    "
                                                                />
                                                                <Dropdown
                                                                    id="district"
                                                                    class="w-36"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .district
                                                                    "
                                                                    :options="
                                                                        selected_city_delivery_new_districts
                                                                    "
                                                                    optionLabel="name"
                                                                    placeholder="行政區"
                                                                    :filter="
                                                                        true
                                                                    "
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.address'
                                                                            ],
                                                                    }"
                                                                    filterPlaceholder="尋找"
                                                                    emptyFilterMessage="沒有符合的結果"
                                                                    :disabled="
                                                                        !formData
                                                                            .delivery_new
                                                                            .city
                                                                    "
                                                                />
                                                                <InputText
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .address
                                                                    "
                                                                    class="w-64"
                                                                    type="text"
                                                                    placeholder="路名及門牌號碼"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.address'
                                                                            ],
                                                                    }"
                                                                    :disabled="
                                                                        !formData
                                                                            .delivery_new
                                                                            .district
                                                                    "
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.address'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.address"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <Checkbox
                                                                    id="delivery_save"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .save
                                                                    "
                                                                    :binary="
                                                                        true
                                                                    "
                                                                />
                                                            </div>
                                                            <div class="input">
                                                                <label
                                                                    for="delivery_save"
                                                                    >儲存到常用收件人</label
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </template>
                                    <!-- 統一超商店到店 -->
                                    <template
                                        v-if="
                                            formData.delivery_method == '711' ||
                                            formData.delivery_method ==
                                                '711_pay'
                                        "
                                    >
                                        <!-- 同付款資料 -->
                                        <div class="my-4">
                                            <RadioButton
                                                id="delivery_as_purchaser"
                                                name="delivery"
                                                value="as_purchaser"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_as_purchaser"
                                                >同付款資料</label
                                            >
                                        </div>
                                        <!-- 同會員資料 -->
                                        <div class="my-4">
                                            <RadioButton
                                                id="delivery_as_contact"
                                                name="delivery"
                                                value="as_contact"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_as_contact"
                                                >同會員資料</label
                                            >
                                            <transition
                                                name="p-toggleable-content"
                                            >
                                                <div
                                                    v-if="
                                                        formData.delivery ==
                                                            'as_contact' &&
                                                        formData.purchaser !=
                                                            'as_contact'
                                                    "
                                                    class="mt-2 ml-2"
                                                >
                                                    <div class="my-1">
                                                        收件人：{{
                                                            $page.props.auth
                                                                .user.name
                                                        }}
                                                    </div>
                                                    <div class="my-1">
                                                        連絡電話：{{
                                                            $page.props.auth
                                                                .user.mobile ??
                                                            $page.props.auth
                                                                .user.tel
                                                        }}
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                        <!-- 其他常用收件人 -->
                                        <div class="my-4">
                                            <RadioButton
                                                id="delivery_address_book"
                                                name="delivery"
                                                value="address_book"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_address_book"
                                                >其他常用收件人</label
                                            >
                                            <div
                                                v-if="
                                                    formData.delivery ==
                                                    'address_book'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div
                                                    v-if="
                                                        $page.props.auth.user
                                                            .preferences
                                                            ?.address_book
                                                    "
                                                >
                                                    <div
                                                        :key="
                                                            contact.name +
                                                            '_' +
                                                            contact.phone +
                                                            '_' +
                                                            contact.email +
                                                            '_' +
                                                            contact
                                                                .shipping_info
                                                                ?.address
                                                        "
                                                        v-for="(
                                                            contact, index
                                                        ) in $page.props.auth
                                                            .user.preferences
                                                            ?.address_book"
                                                    >
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div>
                                                                <RadioButton
                                                                    :id="
                                                                        'delivery_address_book_' +
                                                                        index
                                                                    "
                                                                    name="contact"
                                                                    :value="
                                                                        contact
                                                                    "
                                                                    v-model="
                                                                        formData.delivery_old
                                                                    "
                                                                />
                                                            </div>
                                                            <div class="ml-2">
                                                                <div>
                                                                    <label
                                                                        :for="
                                                                            'delivery_address_book_' +
                                                                            index
                                                                        "
                                                                    >
                                                                        收件人：{{
                                                                            contact.name
                                                                        }}
                                                                    </label>
                                                                </div>
                                                                <div>
                                                                    <label
                                                                        :for="
                                                                            'delivery_address_book_' +
                                                                            index
                                                                        "
                                                                    >
                                                                        連絡電話：{{
                                                                            contact.phone
                                                                        }}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    沒有儲存的常用聯絡人
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 自行填寫 -->
                                        <div class="my-2">
                                            <RadioButton
                                                id="delivery_new"
                                                name="delivery"
                                                value="new"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_new"
                                                >自行填寫</label
                                            >
                                            <transition
                                                name="p-toggleable-content"
                                            >
                                                <div
                                                    v-if="
                                                        formData.delivery ==
                                                        'new'
                                                    "
                                                    class="mt-2 ml-2"
                                                >
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_name"
                                                                    >姓名</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <InputText
                                                                    id="delivery_name"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .name
                                                                    "
                                                                    type="text"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.name'
                                                                            ],
                                                                    }"
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.name'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.name"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_phone"
                                                                    >連絡電話</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <InputText
                                                                    id="delivery_phone"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .phone
                                                                    "
                                                                    placeholder="市話請加上區域碼"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.phone'
                                                                            ],
                                                                    }"
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.phone'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.phone"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </template>
                                </Fieldset>
                            </div>
                        </div>
                        <!-- 訂單備註 -->
                        <div
                            :class="{
                                'w-1/2': flex_direction == 'flex-row',
                                'w-full': flex_direction == 'flex-col',
                            }"
                            class="flex flex-col"
                        >
                            <div class="px-2 py-2">
                                <Fieldset>
                                    <template #legend>訂單備註</template>
                                    <Textarea
                                        v-model="formData.comment"
                                        :autoResize="true"
                                        rows="5"
                                        class="w-full"
                                        placeholder="如有任何備註事項，請填寫於此處。"
                                    />
                                </Fieldset>
                            </div>
                            <div class="px-2 py-2">
                                <Fieldset>
                                    <template #legend>訂單資訊總覽</template>
                                    <div>
                                        商品小計
                                        {{
                                            sum("total_price")
                                                | commaFormat
                                                | priceFormat
                                        }}
                                    </div>
                                    <div>
                                        運費
                                        {{
                                            sum("delivery_fee")
                                                | commaFormat
                                                | priceFormat
                                        }}
                                        <template
                                            v-if="
                                                need_extra_delivery_fee &&
                                                sum('delivery_fee') > 0
                                            "
                                        >
                                            <span class="text-red"
                                                >（含離島地區處理費）</span
                                            >
                                        </template>
                                    </div>
                                    <div>
                                        購物金折抵
                                        <InputNumber
                                            v-model="formData.bonus"
                                            mode="decimal"
                                            :max="
                                                (this.$page.props.auth.user
                                                    .attributes?.bonus ?? 0) >
                                                sum('total_price') +
                                                    sum('delivery_fee')
                                                    ? sum('total_price') +
                                                      sum('delivery_fee')
                                                    : this.$page.props.auth.user
                                                          .attributes?.bonus ??
                                                      0
                                            "
                                            class="w-32"
                                            :disabled="
                                                (this.$page.props.auth.user
                                                    .attributes?.bonus ?? 0) ==
                                                    0 ||
                                                sum('total_price') +
                                                    sum('delivery_fee') ==
                                                    0
                                            "
                                        />
                                        /
                                        {{
                                            ($page.props.auth.user.attributes
                                                ?.bonus ?? 0) >
                                            sum("total_price") +
                                                sum("delivery_fee")
                                                ? sum("total_price") +
                                                  sum("delivery_fee")
                                                : $page.props.auth.user
                                                      .attributes?.bonus ??
                                                  0 | commaFormat
                                        }}
                                    </div>
                                    <div
                                        class="mb-1"
                                        v-if="matchPromotion().length > 0"
                                    >
                                        <div>
                                            優惠活動
                                            <!-- {{ sum("discounts") | commaFormat | priceFormat }} -->
                                        </div>
                                        <ul class="ml-3 text-red text-sm">
                                            <li
                                                :key="'promotion_' + index"
                                                v-for="(
                                                    promotion, index
                                                ) in matchPromotion()"
                                            >
                                                {{ promotion.description }}
                                                折
                                                {{
                                                    promotion.amount
                                                        | commaFormat
                                                        | priceFormat
                                                }}
                                                （CV
                                                {{
                                                    promotion.cv | commaFormat
                                                }}）
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        總計
                                        {{
                                            sum("total_price") +
                                                sum("delivery_fee") -
                                                ((!isNaN(formData.bonus)
                                                    ? formData.bonus
                                                    : 0) > 0
                                                    ? !isNaN(formData.bonus)
                                                        ? formData.bonus
                                                        : 0
                                                    : 0) >
                                            0
                                                ? sum("total_price") +
                                                  sum("delivery_fee") -
                                                  sum("price_discounts") -
                                                  ((!isNaN(formData.bonus)
                                                      ? formData.bonus
                                                      : 0) > 0
                                                      ? !isNaN(formData.bonus)
                                                          ? formData.bonus
                                                          : 0
                                                      : 0)
                                                : 0 | commaFormat | priceFormat
                                        }}
                                    </div>
                                    <div>
                                        總計CV
                                        {{
                                            sum("total_cv") -
                                                sum("cv_discounts") -
                                                (!isNaN(formData.bonus)
                                                    ? formData.bonus
                                                    : 0) >
                                            0
                                                ? sum("total_cv") -
                                                  sum("cv_discounts") -
                                                  (!isNaN(formData.bonus)
                                                      ? formData.bonus
                                                      : 0)
                                                : 0 | commaFormat
                                        }}
                                    </div>
                                    <div
                                        class="text-sm my-2 text-red"
                                        v-if="
                                            selected_products.some((item) => {
                                                return (
                                                    item.is_long_lead == true
                                                );
                                            })
                                        "
                                    >
                                        本次結帳的商品中包含了較長備貨期的品項，我們將於訂單內的所有品項都備齊後，盡快為您寄出！
                                    </div>
                                    <div>
                                        <Button
                                            class="w-full p-button-success"
                                            icon="pi pi-check"
                                            label="前往付款"
                                            @click="proceedPayment"
                                            :disabled="has_empty_field"
                                        />
                                    </div>
                                </Fieldset>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <!-- 未登入 -->
                    <div
                        class="mt-20 w-full flex justify-around"
                        :class="flex_direction"
                    >
                        <div
                            :class="{
                                'w-1/2': flex_direction == 'flex-row',
                                'w-full': flex_direction == 'flex-col',
                            }"
                        >
                            <div class="px-2 py-2" ref="pay_info">
                                <Fieldset>
                                    <template #legend>付款資訊</template>
                                    <div class="my-4">
                                        <div
                                            v-if="formData.purchaser == 'new'"
                                            class="mt-2 ml-2"
                                        >
                                            <div class="my-1">
                                                <div
                                                    class="shopping_cart_form_element_no_border"
                                                >
                                                    <div class="label">
                                                        <label
                                                            for="purchaser_name"
                                                            >姓名</label
                                                        >
                                                    </div>
                                                    <div class="input">
                                                        <InputText
                                                            id="purchaser_name"
                                                            v-model="
                                                                formData
                                                                    .purchaser_new
                                                                    .name
                                                            "
                                                            type="text"
                                                            :class="{
                                                                'p-invalid':
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.name'
                                                                    ],
                                                            }"
                                                        />
                                                        <div
                                                            v-if="
                                                                $page.props
                                                                    .errors[
                                                                    'payload.purchaser.name'
                                                                ]
                                                            "
                                                            class="error_information"
                                                        >
                                                            <i
                                                                class="pi pi-arrow-up"
                                                            />
                                                            {{
                                                                $page.props
                                                                    .errors[
                                                                    "payload.purchaser.name"
                                                                ]
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="my-1">
                                                <div
                                                    class="shopping_cart_form_element_no_border"
                                                >
                                                    <div class="label">
                                                        <label
                                                            for="purchaser_phone"
                                                            >連絡電話</label
                                                        >
                                                    </div>
                                                    <div class="input">
                                                        <InputText
                                                            id="purchaser_phone"
                                                            v-model="
                                                                formData
                                                                    .purchaser_new
                                                                    .phone
                                                            "
                                                            placeholder="市話請加上區域碼"
                                                            :class="{
                                                                'p-invalid':
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.phone'
                                                                    ],
                                                            }"
                                                        />
                                                        <div
                                                            v-if="
                                                                $page.props
                                                                    .errors[
                                                                    'payload.purchaser.phone'
                                                                ]
                                                            "
                                                            class="error_information"
                                                        >
                                                            <i
                                                                class="pi pi-arrow-up"
                                                            />
                                                            {{
                                                                $page.props
                                                                    .errors[
                                                                    "payload.purchaser.phone"
                                                                ]
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="my-1">
                                                <div
                                                    class="shopping_cart_form_element_no_border"
                                                >
                                                    <div class="label">
                                                        <label
                                                            for="purchaser_email"
                                                            >電子郵件</label
                                                        >
                                                    </div>
                                                    <div class="input">
                                                        <InputText
                                                            id="purchaser_phone"
                                                            v-model="
                                                                formData
                                                                    .purchaser_new
                                                                    .email
                                                            "
                                                            :class="{
                                                                'p-invalid':
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.email'
                                                                    ],
                                                            }"
                                                        />
                                                        <div
                                                            v-if="
                                                                $page.props
                                                                    .errors[
                                                                    'payload.purchaser.email'
                                                                ]
                                                            "
                                                            class="error_information"
                                                        >
                                                            <i
                                                                class="pi pi-arrow-up"
                                                            />
                                                            {{
                                                                $page.props
                                                                    .errors[
                                                                    "payload.purchaser.email"
                                                                ]
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="my-1">
                                                <div
                                                    class="shopping_cart_form_element_no_border"
                                                >
                                                    <div class="label">
                                                        <label
                                                            for="purchaser_address"
                                                            >地址</label
                                                        >
                                                    </div>
                                                    <div class="input">
                                                        <Dropdown
                                                            id="purchaser_address"
                                                            class="w-32"
                                                            v-model="
                                                                formData
                                                                    .purchaser_new
                                                                    .city
                                                            "
                                                            :options="
                                                                taiwan_districts
                                                            "
                                                            optionLabel="name"
                                                            placeholder="縣市"
                                                            :class="{
                                                                'p-invalid':
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.address'
                                                                    ],
                                                            }"
                                                            :filter="true"
                                                            filterPlaceholder="尋找"
                                                            emptyFilterMessage="沒有符合的結果"
                                                            @change="
                                                                formData.purchaser_new.district =
                                                                    null
                                                            "
                                                        />
                                                        <Dropdown
                                                            id="district"
                                                            class="w-36"
                                                            v-model="
                                                                formData
                                                                    .purchaser_new
                                                                    .district
                                                            "
                                                            :options="
                                                                selected_city_purchaser_new_districts
                                                            "
                                                            optionLabel="name"
                                                            placeholder="行政區"
                                                            :class="{
                                                                'p-invalid':
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.address'
                                                                    ],
                                                            }"
                                                            :filter="true"
                                                            filterPlaceholder="尋找"
                                                            emptyFilterMessage="沒有符合的結果"
                                                            :disabled="
                                                                !formData
                                                                    .purchaser_new
                                                                    .city
                                                            "
                                                        />
                                                        <InputText
                                                            v-model="
                                                                formData
                                                                    .purchaser_new
                                                                    .address
                                                            "
                                                            class="w-64"
                                                            type="text"
                                                            placeholder="路名及門牌號碼"
                                                            :class="{
                                                                'p-invalid':
                                                                    $page.props
                                                                        .errors[
                                                                        'payload.purchaser.address'
                                                                    ],
                                                            }"
                                                            :disabled="
                                                                !formData
                                                                    .purchaser_new
                                                                    .district
                                                            "
                                                        />
                                                        <div
                                                            v-if="
                                                                $page.props
                                                                    .errors[
                                                                    'payload.purchaser.address'
                                                                ]
                                                            "
                                                            class="error_information"
                                                        >
                                                            <i
                                                                class="pi pi-arrow-up"
                                                            />
                                                            {{
                                                                $page.props
                                                                    .errors[
                                                                    "payload.purchaser.address"
                                                                ]
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fieldset>
                            </div>
                            <div class="px-2 py-2">
                                <Fieldset>
                                    <template #legend>寄送方式</template>
                                    <div class="my-4">
                                        <RadioButton
                                            id="delivery_method_regular"
                                            name="delivery_method"
                                            value="regular"
                                            v-model="formData.delivery_method"
                                        />
                                        <label for="delivery_method_regular"
                                            >一般物流</label
                                        >
                                        <transition name="p-toggleable-content">
                                            <div
                                                v-if="
                                                    formData.delivery_method ==
                                                    'regular'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div
                                                    class="shopping_cart_form_element"
                                                >
                                                    <div class="label">
                                                        <label>到貨時間</label>
                                                    </div>
                                                    <div class="input">
                                                        <SelectButton
                                                            v-model="
                                                                formData.delivery_time
                                                            "
                                                            :options="[
                                                                '上午',
                                                                '下午',
                                                                '全日',
                                                            ]"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                    <div class="my-4">
                                        <RadioButton
                                            id="delivery_method_711"
                                            name="delivery_method"
                                            value="711"
                                            v-model="formData.delivery_method"
                                            :disabled="
                                                this
                                                    .SelectedRefrigeratedProducts
                                                    .length > 0
                                            "
                                        />
                                        <label for="delivery_method_711"
                                            >統一超商店到店 免付款取貨</label
                                        >
                                        <transition name="p-toggleable-content">
                                            <div
                                                v-if="
                                                    formData.delivery_method ==
                                                    '711'
                                                "
                                                class="mt-2 ml-2"
                                            >
                                                <div
                                                    v-if="formData.presco_store"
                                                >
                                                    <div class="my-1">
                                                        門市名稱：{{
                                                            formData
                                                                .presco_store
                                                                .storename
                                                        }}
                                                    </div>
                                                    <div class="my-1">
                                                        門市地址：{{
                                                            formData
                                                                .presco_store
                                                                .storeaddress
                                                        }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="shopping_cart_form_element"
                                                >
                                                    <Button
                                                        :label="
                                                            formData.presco_store
                                                                ? '更改收件門市'
                                                                : '選擇收件門市'
                                                        "
                                                        @click="
                                                            showPrescoStoreSelection
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    class="shopping_cart_form_element_no_border text-sm my-2 text-red"
                                                    v-if="
                                                        this
                                                            .SelectedFrozenProducts
                                                            .length > 0
                                                    "
                                                >
                                                    因結帳的商品中包含冷凍商品，故僅能選擇可配送冷凍溫層之門市。<br />如需選擇其他門市請將冷凍溫層分開結帳。
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                    <div
                                        class="my-4 text-sm text-red"
                                        v-if="
                                            this.SelectedRefrigeratedProducts
                                                .length > 0
                                        "
                                    >
                                        因結帳的商品中包含冷藏商品，故無法選擇統一超商店到店作為寄送方式。<br />如需選擇此寄送方式請將冷藏溫層分開結帳。
                                    </div>
                                </Fieldset>
                            </div>
                            <div class="px-2 py-2">
                                <Fieldset>
                                    <template #legend>收貨資訊</template>
                                    <!-- 一般物流 -->
                                    <template
                                        v-if="
                                            formData.delivery_method ==
                                            'regular'
                                        "
                                    >
                                        <div class="my-4">
                                            <RadioButton
                                                id="delivery_as_purchaser"
                                                name="delivery"
                                                value="as_purchaser"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_as_purchaser"
                                                >同付款資料</label
                                            >
                                        </div>
                                        <div class="my-2">
                                            <RadioButton
                                                id="delivery_new"
                                                name="delivery"
                                                value="new"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_new"
                                                >自行填寫</label
                                            >
                                            <transition
                                                name="p-toggleable-content"
                                            >
                                                <div
                                                    v-if="
                                                        formData.delivery ==
                                                        'new'
                                                    "
                                                    class="mt-2 ml-2"
                                                >
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_name"
                                                                    >姓名</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <InputText
                                                                    id="delivery_name"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .name
                                                                    "
                                                                    type="text"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.name'
                                                                            ],
                                                                    }"
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.name'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.name"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_phone"
                                                                    >連絡電話</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <InputText
                                                                    id="delivery_phone"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .phone
                                                                    "
                                                                    placeholder="市話請加上區域碼"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.phone'
                                                                            ],
                                                                    }"
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.phone'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.phone"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_address"
                                                                    >地址</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <Dropdown
                                                                    id="delivery_address"
                                                                    class="w-32"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .city
                                                                    "
                                                                    :options="
                                                                        taiwan_districts
                                                                    "
                                                                    optionLabel="name"
                                                                    placeholder="縣市"
                                                                    :filter="
                                                                        true
                                                                    "
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.address'
                                                                            ],
                                                                    }"
                                                                    filterPlaceholder="尋找"
                                                                    emptyFilterMessage="沒有符合的結果"
                                                                    @change="
                                                                        formData.delivery_new.district =
                                                                            null
                                                                    "
                                                                />
                                                                <Dropdown
                                                                    id="district"
                                                                    class="w-36"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .district
                                                                    "
                                                                    :options="
                                                                        selected_city_delivery_new_districts
                                                                    "
                                                                    optionLabel="name"
                                                                    placeholder="行政區"
                                                                    :filter="
                                                                        true
                                                                    "
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.address'
                                                                            ],
                                                                    }"
                                                                    filterPlaceholder="尋找"
                                                                    emptyFilterMessage="沒有符合的結果"
                                                                    :disabled="
                                                                        !formData
                                                                            .delivery_new
                                                                            .city
                                                                    "
                                                                />
                                                                <InputText
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .address
                                                                    "
                                                                    class="w-64"
                                                                    type="text"
                                                                    placeholder="路名及門牌號碼"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.address'
                                                                            ],
                                                                    }"
                                                                    :disabled="
                                                                        !formData
                                                                            .delivery_new
                                                                            .district
                                                                    "
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.address'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.address"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </template>
                                    <!-- 統一超商店到店 -->
                                    <template
                                        v-if="
                                            formData.delivery_method == '711' ||
                                            formData.delivery_method ==
                                                '711_pay'
                                        "
                                    >
                                        <div class="my-4">
                                            <RadioButton
                                                id="delivery_as_purchaser"
                                                name="delivery"
                                                value="as_purchaser"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_as_purchaser"
                                                >同付款資料</label
                                            >
                                        </div>
                                        <div class="my-2">
                                            <RadioButton
                                                id="delivery_new"
                                                name="delivery"
                                                value="new"
                                                v-model="formData.delivery"
                                            />
                                            <label for="delivery_new"
                                                >自行填寫</label
                                            >
                                            <transition
                                                name="p-toggleable-content"
                                            >
                                                <div
                                                    v-if="
                                                        formData.delivery ==
                                                        'new'
                                                    "
                                                    class="mt-2 ml-2"
                                                >
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_name"
                                                                    >姓名</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <InputText
                                                                    id="delivery_name"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .name
                                                                    "
                                                                    type="text"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.name'
                                                                            ],
                                                                    }"
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.name'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.name"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="my-1">
                                                        <div
                                                            class="shopping_cart_form_element"
                                                        >
                                                            <div class="label">
                                                                <label
                                                                    for="delivery_phone"
                                                                    >連絡電話</label
                                                                >
                                                            </div>
                                                            <div class="input">
                                                                <InputText
                                                                    id="delivery_phone"
                                                                    v-model="
                                                                        formData
                                                                            .delivery_new
                                                                            .phone
                                                                    "
                                                                    placeholder="市話請加上區域碼"
                                                                    :class="{
                                                                        'p-invalid':
                                                                            $page
                                                                                .props
                                                                                .errors[
                                                                                'payload.delivery.phone'
                                                                            ],
                                                                    }"
                                                                />
                                                                <div
                                                                    v-if="
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            'payload.delivery.phone'
                                                                        ]
                                                                    "
                                                                    class="error_information"
                                                                >
                                                                    <i
                                                                        class="pi pi-arrow-up"
                                                                    />
                                                                    {{
                                                                        $page
                                                                            .props
                                                                            .errors[
                                                                            "payload.delivery.phone"
                                                                        ]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </template>
                                </Fieldset>
                            </div>
                        </div>
                        <div
                            :class="{
                                'w-1/2': flex_direction == 'flex-row',
                                'w-full': flex_direction == 'flex-col',
                            }"
                            class="flex flex-col"
                        >
                            <div class="px-2 py-2">
                                <Fieldset>
                                    <template #legend>訂單備註</template>
                                    <Textarea
                                        v-model="formData.comment"
                                        :autoResize="true"
                                        rows="5"
                                        class="w-full"
                                        placeholder="如有任何備註事項，請填寫於此處。"
                                    />
                                </Fieldset>
                            </div>
                            <div class="px-2 py-2">
                                <Fieldset>
                                    <template #legend>訂單資訊總覽</template>
                                    <div>
                                        商品小計
                                        {{
                                            sum("total_price")
                                                | commaFormat
                                                | priceFormat
                                        }}
                                    </div>
                                    <div>
                                        運費
                                        {{
                                            sum("delivery_fee")
                                                | commaFormat
                                                | priceFormat
                                        }}
                                        <template
                                            v-if="
                                                need_extra_delivery_fee &&
                                                sum('delivery_fee') > 0
                                            "
                                        >
                                            <span class="text-red"
                                                >（含離島地區處理費）</span
                                            >
                                        </template>
                                    </div>
                                    <div v-if="$page.props.auth.user">
                                        購物金折抵
                                        <InputNumber
                                            v-model="formData.bonus"
                                            mode="decimal"
                                            :max="
                                                (this.$page.props.auth.user
                                                    .attributes?.bonus ?? 0) >
                                                sum('total_price') +
                                                    sum('delivery_fee')
                                                    ? sum('total_price') +
                                                      sum('delivery_fee')
                                                    : this.$page.props.auth.user
                                                          .attributes?.bonus ??
                                                      0
                                            "
                                            class="w-32"
                                            :disabled="
                                                (this.$page.props.auth.user
                                                    .attributes?.bonus ?? 0) ==
                                                    0 ||
                                                sum('total_price') +
                                                    sum('delivery_fee') ==
                                                    0
                                            "
                                        />
                                        /
                                        {{
                                            ($page.props.auth.user.attributes
                                                ?.bonus ?? 0) >
                                            sum("total_price") +
                                                sum("delivery_fee")
                                                ? sum("total_price") +
                                                  sum("delivery_fee")
                                                : $page.props.auth.user
                                                      .attributes?.bonus ??
                                                  0 | commaFormat
                                        }}
                                    </div>
                                    <div
                                        class="mb-1"
                                        v-if="matchPromotion().length > 0"
                                    >
                                        <div>
                                            優惠活動
                                            <!-- {{ sum("discounts") | commaFormat | priceFormat }} -->
                                        </div>
                                        <ul class="ml-3 text-red text-sm">
                                            <li
                                                :key="'promotion_' + index"
                                                v-for="(
                                                    promotion, index
                                                ) in matchPromotion()"
                                            >
                                                {{ promotion.description }}
                                                折
                                                {{
                                                    promotion.amount
                                                        | commaFormat
                                                        | priceFormat
                                                }}
                                                （CV
                                                {{
                                                    promotion.cv | commaFormat
                                                }}）
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        總計
                                        {{
                                            sum("total_price") +
                                                sum("delivery_fee") -
                                                ((!isNaN(formData.bonus)
                                                    ? formData.bonus
                                                    : 0) > 0
                                                    ? !isNaN(formData.bonus)
                                                        ? formData.bonus
                                                        : 0
                                                    : 0) >
                                            0
                                                ? sum("total_price") +
                                                  sum("delivery_fee") -
                                                  sum("price_discounts") -
                                                  ((!isNaN(formData.bonus)
                                                      ? formData.bonus
                                                      : 0) > 0
                                                      ? !isNaN(formData.bonus)
                                                          ? formData.bonus
                                                          : 0
                                                      : 0)
                                                : 0 | commaFormat | priceFormat
                                        }}
                                    </div>
                                    <div>
                                        總計CV
                                        {{
                                            sum("total_cv") -
                                                sum("cv_discounts") -
                                                (!isNaN(formData.bonus)
                                                    ? formData.bonus
                                                    : 0) >
                                            0
                                                ? sum("total_cv") -
                                                  sum("cv_discounts") -
                                                  (!isNaN(formData.bonus)
                                                      ? formData.bonus
                                                      : 0)
                                                : 0 | commaFormat
                                        }}
                                        <small
                                            >（登入會員結帳以享有購物回饋）</small
                                        >
                                    </div>
                                    <div
                                        class="text-sm my-2 text-red"
                                        v-if="
                                            selected_products.some((item) => {
                                                return (
                                                    item.is_long_lead == true
                                                );
                                            })
                                        "
                                    >
                                        本次結帳的商品中包含了較長備貨期的品項，我們將於訂單內的所有品項都備齊後，盡快為您寄出！
                                    </div>
                                    <div class="mt-2">
                                        <Button
                                            class="w-full p-button-success"
                                            icon="pi pi-check"
                                            label="前往付款"
                                            @click="proceedPayment"
                                            :disabled="has_empty_field"
                                        />
                                    </div>
                                </Fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="text-fh-blue text-xl text-center my-48">
                您的購物車中沒有商品
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import InputMask from "primevue/inputmask";
import Fieldset from "primevue/fieldset";
import RadioButton from "primevue/radiobutton";
import Dropdown from "primevue/dropdown";
import Textarea from "primevue/textarea";
import Button from "primevue/button";
import Carousel from "../Products/Components/Carousel";
import TaiwanDistricts from "@/TaiwanDistricts.json";
import SelectButton from "primevue/selectbutton";
import Checkbox from "primevue/checkbox";

export default {
    components: {
        DataTable,
        Column,
        Fieldset,
        InputNumber,
        InputText,
        InputMask,
        RadioButton,
        Dropdown,
        Textarea,
        Button,
        Carousel,
        SelectButton,
        Checkbox,
    },
    filters: {
        priceFormat: function (value) {
            return "$" + value;
        },
        commaFormat: function (value) {
            return value
                .toString()
                .replace(
                    /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
                    function (all, pre, groupOf3Digital) {
                        return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
                    }
                );
        },
    },
    layout: Layout,
    watch: {
        SelectedFrozenProducts: {
            handler: function (newValue, oldValue) {
                if (oldValue.length == 0 && newValue.length > 0) {
                    this.formData.presco_store = null;
                    this.formData.presco_store_pay = null;
                }
            },
        },
        SelectedRefrigeratedProducts: {
            handler: function (newValue, oldValue) {
                if (
                    newValue.length > 0 &&
                    (this.formData.delivery_method == "711" ||
                        this.formData.delivery_method == "711_pay")
                ) {
                    this.formData.delivery_method = "regular";
                }
            },
        },
    },
    mounted() {
        if (!this.$page.props.auth.user) this.formData.purchaser = "new";

        fbq("track", "InitiateCheckout");
        console.log("fbq.track.InitiateCheckout");

        this.expandAllPacks();

        window.onresize = () => {
            this.windowWidth = window.innerWidth;
        };

        //7-11選店
        if (this.$page.props.delivery_info) {
            //購物車狀態
            _.forEach(
                this.$page.props.selected_products_by_type,
                (items, delivery_type) => {
                    items.forEach((item, index) => {
                        this.$page.props.selected_products_by_type[
                            delivery_type
                        ][index] = this.shopping_cart.products[
                            delivery_type
                        ].find((product) => {
                            return (
                                product.id == item.id &&
                                product.type == item.type &&
                                product.quantity > 0
                            );
                        });
                    });

                    this.$page.props.selected_products_by_type[delivery_type] =
                        _.compact(
                            this.$page.props.selected_products_by_type[
                                delivery_type
                            ]
                        );
                }
            );
            this.selected_products_by_type =
                this.$page.props.selected_products_by_type;
            this.formData = this.$page.props.formData;

            setTimeout(() => {
                //免付款取貨
                if (
                    this.$page.props.delivery_info.TempVar === "70Z" ||
                    this.$page.props.delivery_info.TempVar === "75N"
                ) {
                    this.formData.delivery_method = "711";
                    this.formData.presco_store = this.$page.props.delivery_info;
                }

                //到店付款
                if (
                    this.$page.props.delivery_info.TempVar === "70Y" ||
                    this.$page.props.delivery_info.TempVar === "75A"
                ) {
                    this.formData.delivery_method = "711_pay";
                    this.formData.presco_store_pay =
                        this.$page.props.delivery_info;
                }

                if (!this.$page.props.flash.error && this.$refs.pay_info) {
                    this.$refs.pay_info.scrollIntoView({ behavior: "instant" });
                }
            }, 0);
        }
    },
    data() {
        return {
            delivery_types: {
                normal: "常溫商品",
                refrigerated: "冷藏商品",
                frozen: "冷凍商品",
            },
            appliedFreeShipping: {
                normal: false,
                refrigerated: false,
                frozen: false,
            },
            selected_products_by_type: {
                normal: [],
                refrigerated: [],
                frozen: [],
            },
            expended_products_by_type: {
                normal: [],
                refrigerated: [],
                frozen: [],
            },
            // shopping_cart: this.$parent.shopping_cart,
            // shoppingCartChanged: false,
            update_shopping_cart_value: 0,
            isLoading: false,
            windowWidth: window.innerWidth,
            showTopMenu: false,
            formData: {
                purchaser: "as_contact",
                purchaser_new: {
                    name: null,
                    phone: null,
                    city: null,
                    district: null,
                    address: null,
                },
                delivery: "as_purchaser",
                delivery_new: {
                    name: null,
                    phone: null,
                    city: null,
                    district: null,
                    address: null,
                    save: false,
                },
                delivery_old: {
                    name: null,
                    phone: null,
                    address: null,
                },
                delivery_presco: {
                    name: null,
                    phone: null,
                },
                bonus: 0,
                comment: null,
                delivery_method: "regular",
                delivery_time: "全日",
                presco_store: null,
                presco_store_pay: null,
            },
            taiwan_districts: TaiwanDistricts,
            allSelected: {
                frozen: false,
                refrigerated: false,
                normal: false,
            },
        };
    },
    computed: {
        SelectedFrozenProducts: function () {
            return JSON.parse(
                JSON.stringify(this.selected_products_by_type.frozen)
            );
        },
        SelectedRefrigeratedProducts: function () {
            return JSON.parse(
                JSON.stringify(this.selected_products_by_type.refrigerated)
            );
        },
        need_extra_delivery_fee() {
            if (!this.$page.props.auth?.user) return false;

            let extra_delivery_fee_zone = [
                "連江縣",
                "釣魚臺",
                "南海島",
                "澎湖縣",
                "金門縣",
            ];

            let current_zone = null;

            if (this.formData.delivery == "as_purchaser") {
                if (this.formData.purchaser == "as_contact") {
                    current_zone =
                        this.$page.props.auth.user.shipping_info?.city;
                }
                if (this.formData.purchaser == "new") {
                    current_zone = this.formData.purchaser_new.city?.name;
                }
            }

            if (this.formData.delivery == "as_contact") {
                current_zone = this.$page.props.auth.user.shipping_info?.city;
            }

            if (this.formData.delivery == "address_book") {
                current_zone = this.formData.delivery_old.shipping_info?.city;
            }

            if (this.formData.delivery == "new") {
                current_zone = this.formData.delivery_new.city?.name;
            }

            return extra_delivery_fee_zone.includes(current_zone);
        },
        selected_products() {
            return _.flatten(Object.values(this.selected_products_by_type));
        },
        existing_delivery_types() {
            return _.keys(this.shopping_cart.products);
        },
        shopping_cart() {
            return this.$parent.shopping_cart;
        },
        flex_direction() {
            if (this.windowWidth >= 480) return "flex-row";
            return "flex-col";
        },
        selected_city_purchaser_new_districts() {
            if (!this.formData.purchaser_new.city) return [];
            return this.formData.purchaser_new.city.districts;
        },
        selected_city_delivery_new_districts() {
            if (!this.formData.delivery_new.city) return [];
            return this.formData.delivery_new.city.districts;
        },
        has_empty_field() {
            if (this.selected_products.length == 0) return true;

            // if (this.formData.purchaser == "as_contact") {
            //   if (
            //     !this.$page.props.auth.user.shipping_info ||
            //     !this.$page.props.auth.user.shipping_info?.district?.zip ||
            //     !this.$page.props.auth.user.shipping_info?.city ||
            //     !this.$page.props.auth.user.shipping_info?.district?.name ||
            //     !this.$page.props.auth.user.shipping_info?.address
            //   )
            //     return true;
            // } else {
            //   if (
            //     !(
            //       this.formData.purchaser_new.name &&
            //       this.formData.purchaser_new.phone &&
            //       this.formData.purchaser_new.email &&
            //       this.formData.purchaser_new.city &&
            //       this.formData.purchaser_new.district &&
            //       this.formData.purchaser_new.address
            //     )
            //   )
            //     return true;
            // }

            if (this.formData.purchaser != "as_contact") {
                if (
                    !(
                        this.formData.purchaser_new.name &&
                        this.formData.purchaser_new.phone &&
                        this.formData.purchaser_new.email &&
                        this.formData.purchaser_new.city &&
                        this.formData.purchaser_new.district &&
                        this.formData.purchaser_new.address
                    )
                )
                    return true;
            }

            if (this.formData.delivery_method == "regular") {
                if (this.formData.delivery == "as_purchaser") {
                    if (this.formData.purchaser == "as_contact") {
                        if (
                            !this.$page.props.auth.user.shipping_info ||
                            !this.$page.props.auth.user.shipping_info?.district
                                ?.zip ||
                            !this.$page.props.auth.user.shipping_info?.city ||
                            !this.$page.props.auth.user.shipping_info?.district
                                ?.name ||
                            !this.$page.props.auth.user.shipping_info?.address
                        )
                            return true;
                    } else {
                        if (
                            !(
                                this.formData.purchaser_new.name &&
                                this.formData.purchaser_new.phone &&
                                this.formData.purchaser_new.email &&
                                this.formData.purchaser_new.city &&
                                this.formData.purchaser_new.district &&
                                this.formData.purchaser_new.address
                            )
                        )
                            return true;
                    }
                }

                if (this.formData.delivery == "as_contact") {
                    if (
                        !this.$page.props.auth.user.shipping_info ||
                        !this.$page.props.auth.user.shipping_info?.district
                            ?.zip ||
                        !this.$page.props.auth.user.shipping_info?.city ||
                        !this.$page.props.auth.user.shipping_info?.district
                            ?.name ||
                        !this.$page.props.auth.user.shipping_info?.address
                    )
                        return true;
                }

                if (this.formData.delivery == "address_book") {
                    if (
                        !(
                            this.formData.delivery_old.name &&
                            this.formData.delivery_old.phone &&
                            this.formData.delivery_old.shipping_info
                        )
                    )
                        return true;
                }

                if (this.formData.delivery == "new") {
                    if (
                        !(
                            this.formData.delivery_new.name &&
                            this.formData.delivery_new.phone &&
                            this.formData.delivery_new.city &&
                            this.formData.delivery_new.district &&
                            this.formData.delivery_new.address
                        )
                    )
                        return true;
                }
            }

            if (
                this.formData.delivery_method == "711" ||
                this.formData.delivery_method == "711_pay"
            ) {
                if (
                    this.formData.delivery_method == "711" &&
                    !this.formData.presco_store
                )
                    return true;

                if (
                    this.formData.delivery_method == "711_pay" &&
                    !this.formData.presco_store_pay
                )
                    return true;

                if (
                    this.formData.delivery === "as_purchaser" &&
                    this.formData.purchaser !== "as_contact"
                ) {
                    if (
                        !(
                            this.formData.purchaser_new.name &&
                            this.formData.purchaser_new.phone &&
                            this.formData.purchaser_new.email &&
                            this.formData.purchaser_new.city &&
                            this.formData.purchaser_new.district &&
                            this.formData.purchaser_new.address
                        )
                    )
                        return true;
                }

                if (this.formData.delivery == "address_book") {
                    if (
                        !(
                            this.formData.delivery_old.name &&
                            this.formData.delivery_old.phone
                        )
                    )
                        return true;
                }

                if (this.formData.delivery == "new") {
                    if (
                        !(
                            this.formData.delivery_new.name &&
                            this.formData.delivery_new.phone
                        )
                    )
                        return true;
                }
            }

            // if (this.formData.delivery_method == "711_pay") {
            //     if (
            //         !(
            //             this.formData.presco_store_pay &&
            //             this.formData.delivery_presco.name &&
            //             this.formData.delivery_presco.phone
            //         )
            //     )
            //         return true;
            // }

            return false;
        },
    },
    methods: {
        showPrescoStoreSelection() {
            //   var select_store_window = window.open(
            //     route("presco.select_store", [
            //       this.$page.props.identifier,
            //       this.formData.delivery_method == "711_pay" ? "pay" : null,
            //       this.SelectedFrozenProducts.length > 0 ? { 'type': 'frozen' } : { 'type': 'regular' },
            //     ]),
            //     "PrescoSelectStore"
            //   );
            //   var select_store_window_close_detector = setInterval(
            //     function () {
            //       if (select_store_window.closed) {
            //         clearInterval(select_store_window_close_detector);
            //         axios
            //           .get(route("presco.selected_store", this.$page.props.identifier))
            //           .then((response) => {
            //             if (this.formData.delivery_method == "711")
            //               this.formData.presco_store = response.data;
            //             if (this.formData.delivery_method == "711_pay")
            //               this.formData.presco_store_pay = response.data;
            //           });
            //       }
            //     }.bind(this),
            //     1000
            //   );

            //購物車狀態暫存
            axios
                .post(route("selected_product_cached"), {
                    identifier: this.$page.props.identifier,
                    selected_products_by_type: this.selected_products_by_type,
                    formData: this.formData,
                })
                .then(function (response) {
                    console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                });

            //頁面跳轉
            window.top.location.href = route("presco.select_store", [
                this.$page.props.identifier,
                this.formData.delivery_method == "711_pay" ? "pay" : null,
                this.SelectedFrozenProducts.length > 0
                    ? { type: "frozen" }
                    : { type: "regular" },
            ]);
        },
        selectType(delivery_type) {
            this.selected_products_by_type[delivery_type] = [];

            if (!this.allSelected[delivery_type]) {
                this.selected_products_by_type[delivery_type] =
                    this.$parent.shopping_cart.products[delivery_type].filter(
                        (products) => products.type != "add-on"
                    );
            }

            this.checkAvailability(
                delivery_type,
                this.selected_products_by_type[delivery_type]
            );
        },
        matchPromotion() {
            let result = [];

            this.$page.props.promotions.forEach((rule) => {
                let total_price = 0;
                let total_cv = 0;

                if (
                    this.shopping_cart.products.normal &&
                    this.selected_products_by_type["normal"].length > 0 &&
                    rule.payload.order_discount.delivery_type.normal == true
                ) {
                    total_price +=
                        _.sumBy(
                            this.selected_products_by_type["normal"],
                            (item) => {
                                return item.total_price;
                            }
                        ) +
                        _.sumBy(
                            this.shopping_cart.products["normal"].filter(
                                (products) => products.type == "add-on"
                            ),
                            (item) => {
                                return item.total_price;
                            }
                        );

                    total_cv +=
                        _.sumBy(
                            this.selected_products_by_type["normal"],
                            (item) => {
                                return item.total_cv;
                            }
                        ) +
                        _.sumBy(
                            this.shopping_cart.products["normal"].filter(
                                (products) => products.type == "add-on"
                            ),
                            (item) => {
                                return item.total_cv;
                            }
                        );
                }

                if (
                    this.shopping_cart.products.refrigerated &&
                    this.selected_products_by_type["refrigerated"].length > 0 &&
                    rule.payload.order_discount.delivery_type.refrigerated ==
                        true
                ) {
                    total_price +=
                        _.sumBy(
                            this.selected_products_by_type["refrigerated"],
                            (item) => {
                                return item.total_price;
                            }
                        ) +
                        _.sumBy(
                            this.shopping_cart.products["refrigerated"].filter(
                                (products) => products.type == "add-on"
                            ),
                            (item) => {
                                return item.total_price;
                            }
                        );

                    total_cv +=
                        _.sumBy(
                            this.selected_products_by_type["refrigerated"],
                            (item) => {
                                return item.total_cv;
                            }
                        ) +
                        _.sumBy(
                            this.shopping_cart.products["refrigerated"].filter(
                                (products) => products.type == "add-on"
                            ),
                            (item) => {
                                return item.total_cv;
                            }
                        );
                }

                if (
                    this.shopping_cart.products.frozen &&
                    this.selected_products_by_type["frozen"].length > 0 &&
                    rule.payload.order_discount.delivery_type.frozen == true
                ) {
                    total_price +=
                        _.sumBy(
                            this.selected_products_by_type["frozen"],
                            (item) => {
                                return item.total_price;
                            }
                        ) +
                        _.sumBy(
                            this.shopping_cart.products["frozen"].filter(
                                (products) => products.type == "add-on"
                            ),
                            (item) => {
                                return item.total_price;
                            }
                        );

                    total_cv +=
                        _.sumBy(
                            this.selected_products_by_type["frozen"],
                            (item) => {
                                return item.total_cv;
                            }
                        ) +
                        _.sumBy(
                            this.shopping_cart.products["frozen"].filter(
                                (products) => products.type == "add-on"
                            ),
                            (item) => {
                                return item.total_cv;
                            }
                        );
                }

                if (
                    rule.payload.condition.type == "always" ||
                    (rule.payload.condition.type == "greater" &&
                        rule.payload.condition.amount <= total_price)
                ) {
                    if (rule.payload.order_discount.type == "percentage_off") {
                        result.push({
                            description: rule.description,
                            event_tag: rule.payload.event_tag,
                            amount: Math.floor(
                                total_price *
                                    (rule.payload.order_discount.percentage /
                                        100)
                            ),
                            cv: Math.round(
                                total_cv *
                                    (rule.payload.order_discount.percentage /
                                        100)
                            ),
                        });
                    } else if (
                        rule.payload.order_discount.type == "fixed_amount"
                    ) {
                        result.push({
                            description: rule.description,
                            event_tag: rule.payload.event_tag,
                            amount: rule.payload.order_discount.amount,
                            cv: Math.round(
                                rule.payload.order_discount.amount / 2
                            ),
                        });
                    }
                }
            });

            return result;
        },
        updateSelectStatus() {
            _.forEach(
                this.selected_products_by_type,
                (items, delivery_type) => {
                    if (this.shopping_cart.products[delivery_type]) {
                        if (
                            this.selected_products_by_type[delivery_type]
                                .length ==
                            this.shopping_cart.products[delivery_type].filter(
                                (product) =>
                                    product.type != "add-on" &&
                                    product.quantity > 0
                            ).length
                        ) {
                            this.allSelected[delivery_type] = true;
                        } else {
                            this.allSelected[delivery_type] = false;
                        }
                    }
                }
            );
        },
        checkAvailability(type, selected) {
            this.selected_products_by_type[type] = selected.filter((item) => {
                return item.quantity > 0;
            });

            this.updateSelectStatus();
        },
        sum(property, delivery_type = null) {
            if (property == "delivery_fee") {
                if (delivery_type !== null) {
                    let delivery_fee_extra_handled =
                        this.shopping_cart.delivery_fees[delivery_type];

                    if (this.need_extra_delivery_fee) {
                        delivery_fee_extra_handled += 100;
                    }

                    return this.applyFreeShipping(
                        delivery_type,
                        delivery_fee_extra_handled
                    );
                } else {
                    let total_delivery_fee = 0;
                    _.forEach(
                        this.selected_products_by_type,
                        (items, delivery_type) => {
                            let delivery_fee_extra_handled =
                                this.shopping_cart.delivery_fees[delivery_type];

                            if (this.need_extra_delivery_fee) {
                                delivery_fee_extra_handled += 100;
                            }

                            if (items.length > 0) {
                                total_delivery_fee += this.applyFreeShipping(
                                    delivery_type,
                                    delivery_fee_extra_handled
                                );
                            }
                        }
                    );
                    return total_delivery_fee;
                }
            } else if (property == "price_discounts") {
                return _.sumBy(this.matchPromotion(), (promotion) => {
                    return promotion.amount;
                });
            } else if (property == "cv_discounts") {
                return _.sumBy(this.matchPromotion(), (promotion) => {
                    return promotion.cv;
                });
            } else {
                if (delivery_type !== null) {
                    let sum_add_on = 0;
                    let sum = _.sumBy(
                        this.selected_products_by_type[delivery_type],
                        property
                    );

                    if (
                        this.selected_products_by_type[delivery_type].length > 0
                    ) {
                        sum_add_on = _.sumBy(
                            this.shopping_cart.products[delivery_type].filter(
                                (products) => products.type == "add-on"
                            ),
                            property
                        );
                    }
                    return sum + sum_add_on;
                } else {
                    let sum = _.sumBy(this.selected_products, property);
                    let sum_add_on = 0;
                    _.forEach(
                        this.selected_products_by_type,
                        (items, delivery_type) => {
                            if (items.length > 0) {
                                sum_add_on += _.sumBy(
                                    this.shopping_cart.products[
                                        delivery_type
                                    ].filter(
                                        (products) => products.type == "add-on"
                                    ),
                                    property
                                );
                            }
                        }
                    );
                    return sum + sum_add_on;
                }
            }
        },
        matchFreeShipping(delivery_type) {
            let result = null;
            let total_price =
                _.sumBy(
                    this.selected_products_by_type[delivery_type],
                    (item) => {
                        return item.total_price;
                    }
                ) +
                _.sumBy(
                    this.shopping_cart.products[delivery_type].filter(
                        (products) => products.type == "add-on"
                    ),
                    (item) => {
                        return item.total_price;
                    }
                );

            // 20230822 依運輸方式篩選可用的免運規則
            let acceptedDeliveryMethod = null;
            switch (this.formData.delivery_method) {
                case "regular":
                    acceptedDeliveryMethod = "regular";
                    break;
                case "711":
                case "711_pay":
                    acceptedDeliveryMethod = "711";
                    break;
            }

            this.$page.props.free_shippings
                .filter((rule) => {
                    return rule.delivery_method == acceptedDeliveryMethod;
                })
                .forEach(function (rule) {
                    if (result) {
                        return false;
                    }

                    if (
                        (rule.condition.type == "always" &&
                            rule.delivery_type[delivery_type] == true) ||
                        (rule.condition.type == "greater" &&
                            rule.condition.amount <= total_price &&
                            rule.delivery_type[delivery_type] == true)
                    ) {
                        result = rule.description;
                    }
                });

            return result;
        },
        applyFreeShipping(delivery_type, fee) {
            if (this.selected_products_by_type[delivery_type].length == 0) {
                this.appliedFreeShipping[delivery_type] = false;
                return 0;
            }

            if (this.matchFreeShipping(delivery_type)) {
                this.appliedFreeShipping[delivery_type] = true;
                return 0;
            } else {
                this.appliedFreeShipping[delivery_type] = false;
            }

            return fee;
        },
        selectAll() {
            this.selected_products_by_type = Object.assign(
                {},
                { normal: [], refrigerated: [], frozen: [] }
            );

            Object.keys(this.$parent.shopping_cart.products).forEach(
                (delivery_type) => {
                    this.selected_products_by_type[delivery_type] =
                        this.$parent.shopping_cart.products[
                            delivery_type
                        ].filter((products) => products.type != "add-on");

                    this.checkAvailability(
                        delivery_type,
                        this.selected_products_by_type[delivery_type]
                    );
                }
            );
        },
        expandAllPacks() {
            this.expended_products_by_type = Object.assign(
                {},
                { normal: [], refrigerated: [], frozen: [] }
            );

            Object.keys(this.$parent.shopping_cart.products).forEach(
                (delivery_type) => {
                    this.expended_products_by_type[delivery_type] =
                        this.$parent.shopping_cart.products[
                            delivery_type
                        ].filter((products) => products.type == "pack");
                }
            );
        },
        organizeIncludesData(pack) {
            pack.includes.forEach((merchandise) => {});
        },
        setUpdateShoppingCartValue(item) {
            this.update_shopping_cart_value = item.quantity;
        },
        handleInputQuantityChange(product) {
            if (product.quantity < 1) {
                product.quantity = 1;
            } else if (product.quantity >= product.in_stock) {
                product.quantity = product.in_stock;
            }
            product.desired = product.quantity;
        },
        hasAddOn(products) {
            return (
                _.findIndex(products, {
                    type: "add-on",
                }) >= 0
            );
        },
        removeFromShoppingCart(item) {
            this.isLoading = true;

            axios
                .delete("/api/shopping-cart", {
                    data: {
                        payload: [
                            {
                                type: item.type,
                                id: item.id,
                                includes: item.includes,
                            },
                        ],
                    },
                })
                .then((response) => {
                    Object.keys(this.shopping_cart.products).forEach(
                        (delivery_type) => {
                            // console.log("取消選擇");
                            this.selected_products_by_type[delivery_type] =
                                _.filter(
                                    this.selected_products_by_type[
                                        delivery_type
                                    ] ?? [],
                                    (oldItem) => {
                                        return (
                                            _.findIndex(
                                                response.data.products[
                                                    delivery_type
                                                ] ?? [],
                                                (newItem) => {
                                                    return (
                                                        newItem.id ==
                                                            oldItem.id &&
                                                        newItem.type ==
                                                            oldItem.type &&
                                                        _.isEqual(
                                                            newItem.includes,
                                                            oldItem.includes
                                                        )
                                                    );
                                                }
                                            ) >= 0
                                        );
                                    }
                                );

                            // console.log("刪除商品");
                            this.shopping_cart.products[delivery_type] =
                                _.filter(
                                    this.shopping_cart.products[
                                        delivery_type
                                    ] ?? [],
                                    (oldItem) => {
                                        return (
                                            _.findIndex(
                                                response.data.products[
                                                    delivery_type
                                                ] ?? [],
                                                (newItem) => {
                                                    return (
                                                        newItem.id ==
                                                            oldItem.id &&
                                                        newItem.type ==
                                                            oldItem.type &&
                                                        _.isEqual(
                                                            newItem.includes,
                                                            oldItem.includes
                                                        )
                                                    );
                                                }
                                            ) >= 0
                                        );
                                    }
                                );
                        }
                    );

                    // console.log("移除溫層");
                    this.shopping_cart.products = _.omitBy(
                        this.shopping_cart.products,
                        _.isEmpty
                    );

                    this.$toast.add({
                        severity: "success",
                        summary: "從購物車移除成功",
                        detail: item.name,
                        life: 3000,
                    });
                })
                .catch((error) => {
                    console.error(error);
                    this.$toast.add({
                        severity: "error",
                        summary: "從購物車移除失敗",
                        detail: "請聯繫我們取得進一步的協助",
                        closable: false,
                        life: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                    // this.shoppingCartChanged = false;
                });
        },
        updateShoppingCart(product) {
            if (product.quantity == this.update_shopping_cart_value) return;

            this.isLoading = true;

            // this.$inertia.patch(
            //   "/api/shopping-cart",
            //   {
            //     payload: this.shopping_cart.products,
            //   },
            //   {
            //     preserveState: true,
            //     preserveScroll: true,
            //     onSuccess: (page) => {
            //       this.$toast.add({
            //         severity: "success",
            //         summary: "購物車已更新",
            //         life: 3000,
            //       });
            //     },
            //     onError: (errors) => {
            //       this.$toast.add({
            //         severity: "error",
            //         summary: "更新購物車失敗",
            //         detail: "請聯繫我們取得進一步的協助",
            //         closable: false,
            //         life: 5000,
            //       });
            //     },
            //     onFinish: (visit) => {
            //       this.isLoading = false;
            //     },
            //   }
            // );

            axios
                .patch("/api/shopping-cart", {
                    payload: this.shopping_cart.products,
                })
                .then((response) => {
                    _.merge(this.shopping_cart, response.data);
                    this.$toast.add({
                        severity: "success",
                        summary: "購物車已更新",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    console.error(error);
                    this.$toast.add({
                        severity: "error",
                        summary: "更新購物車失敗",
                        detail: "請聯繫我們取得進一步的協助",
                        closable: false,
                        life: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                    // this.shoppingCartChanged = false;
                });
        },
        goToProductPage(slug) {
            this.$inertia.visit(route("product", slug));
        },
        checkOut() {
            var temp_selected_products = {};

            Object.keys(this.shopping_cart.products).forEach(
                (delivery_type) => {
                    if (
                        this.selected_products_by_type[delivery_type].length > 0
                    ) {
                        temp_selected_products[delivery_type] = _.concat(
                            this.selected_products_by_type[delivery_type],
                            this.shopping_cart.products[delivery_type].filter(
                                (products) => products.type == "add-on"
                            )
                        );
                    }
                }
            );

            this.$inertia.post("/shopping-cart", {
                payload: temp_selected_products,
            });
        },
        proceedPayment() {
            let temp_selected_products = {};

            Object.keys(this.shopping_cart.products).forEach(
                (delivery_type) => {
                    if (
                        this.selected_products_by_type[delivery_type].length > 0
                    ) {
                        temp_selected_products[delivery_type] = _.concat(
                            this.selected_products_by_type[delivery_type],
                            this.shopping_cart.products[delivery_type].filter(
                                (products) => products.type == "add-on"
                            )
                        );
                    }
                }
            );

            let temp_purchaser_data = {};

            switch (this.formData.purchaser) {
                case "as_contact":
                    temp_purchaser_data = {
                        name: this.$page.props.auth.user.name,
                        phone:
                            this.$page.props.auth.user.mobile ??
                            this.$page.props.auth.user.tel,
                        email: this.$page.props.auth.user.email,
                        address:
                            this.$page.props.auth.user.shipping_info?.district
                                ?.zip +
                            " " +
                            this.$page.props.auth.user.shipping_info?.city +
                            this.$page.props.auth.user.shipping_info?.district
                                ?.name +
                            this.$page.props.auth.user.shipping_info?.address,
                    };
                    break;

                case "new":
                    temp_purchaser_data = {
                        name: this.formData.purchaser_new.name,
                        phone: this.formData.purchaser_new.phone,
                        email: this.formData.purchaser_new.email,
                        address:
                            this.formData.purchaser_new.district?.zip &&
                            this.formData.purchaser_new.city?.name &&
                            this.formData.purchaser_new.district?.name &&
                            this.formData.purchaser_new.address
                                ? this.formData.purchaser_new.district?.zip +
                                  " " +
                                  this.formData.purchaser_new.city?.name +
                                  this.formData.purchaser_new.district?.name +
                                  this.formData.purchaser_new.address
                                : null,
                    };
                    break;
            }

            let temp_delivery_data = {};
            let temp_adding_delivery_data = null;

            switch (this.formData.delivery_method) {
                case "711":
                    switch (this.formData.delivery) {
                        case "as_purchaser":
                            temp_delivery_data = {
                                name: temp_purchaser_data.name,
                                phone: temp_purchaser_data.phone,
                            };
                            break;

                        case "as_contact":
                            temp_delivery_data = {
                                name: this.$page.props.auth.user.name,
                                phone:
                                    this.$page.props.auth.user.mobile ??
                                    this.$page.props.auth.user.tel,
                            };
                            break;

                        case "address_book":
                            temp_delivery_data = {
                                name: this.formData.delivery_old.name,
                                phone: this.formData.delivery_old.phone,
                            };
                            break;

                        case "new":
                            temp_delivery_data = {
                                name: this.formData.delivery_new.name,
                                phone: this.formData.delivery_new.phone,
                            };
                            break;
                    }
                    temp_delivery_data["storeid"] =
                        this.formData.presco_store.storeid;
                    temp_delivery_data["storename"] =
                        this.formData.presco_store.storename;
                    temp_delivery_data["storeaddress"] =
                        this.formData.presco_store.storeaddress;
                    break;

                case "711_pay":
                    switch (this.formData.delivery) {
                        case "as_purchaser":
                            temp_delivery_data = {
                                name: temp_purchaser_data.name,
                                phone: temp_purchaser_data.phone,
                            };
                            break;

                        case "as_contact":
                            temp_delivery_data = {
                                name: this.$page.props.auth.user.name,
                                phone:
                                    this.$page.props.auth.user.mobile ??
                                    this.$page.props.auth.user.tel,
                            };
                            break;

                        case "address_book":
                            temp_delivery_data = {
                                name: this.formData.delivery_old.name,
                                phone: this.formData.delivery_old.phone,
                            };
                            break;

                        case "new":
                            temp_delivery_data = {
                                name: this.formData.delivery_new.name,
                                phone: this.formData.delivery_new.phone,
                            };
                            break;
                    }
                    temp_delivery_data["storeid"] =
                        this.formData.presco_store_pay.storeid;
                    temp_delivery_data["storename"] =
                        this.formData.presco_store_pay.storename;
                    temp_delivery_data["storeaddress"] =
                        this.formData.presco_store_pay.storeaddress;
                    break;

                case "regular":
                    switch (this.formData.delivery) {
                        case "as_purchaser":
                            temp_delivery_data = temp_purchaser_data;
                            break;

                        case "as_contact":
                            temp_delivery_data = {
                                name: this.$page.props.auth.user.name,
                                phone:
                                    this.$page.props.auth.user.mobile ??
                                    this.$page.props.auth.user.tel,
                                address:
                                    this.$page.props.auth.user.shipping_info
                                        ?.district?.zip +
                                    " " +
                                    this.$page.props.auth.user.shipping_info
                                        ?.city +
                                    this.$page.props.auth.user.shipping_info
                                        ?.district?.name +
                                    this.$page.props.auth.user.shipping_info
                                        ?.address,
                            };
                            break;

                        case "address_book":
                            temp_delivery_data = {
                                name: this.formData.delivery_old.name,
                                phone: this.formData.delivery_old.phone,
                                address: this.formData.delivery_old
                                    .shipping_info.address
                                    ? this.formData.delivery_old.shipping_info
                                          .district?.zip +
                                      " " +
                                      this.formData.delivery_old.shipping_info
                                          .city +
                                      this.formData.delivery_old.shipping_info
                                          .district?.name +
                                      this.formData.delivery_old.shipping_info
                                          .address
                                    : null,
                            };
                            break;

                        case "new":
                            temp_delivery_data = {
                                name: this.formData.delivery_new.name,
                                phone: this.formData.delivery_new.phone,
                                address:
                                    this.formData.delivery_new.district?.zip &&
                                    this.formData.delivery_new.city?.name &&
                                    this.formData.delivery_new.district?.name &&
                                    this.formData.delivery_new.address
                                        ? this.formData.delivery_new.district
                                              ?.zip +
                                          " " +
                                          this.formData.delivery_new.city
                                              ?.name +
                                          this.formData.delivery_new.district
                                              ?.name +
                                          this.formData.delivery_new.address
                                        : null,
                                save: this.formData.delivery_new.save,
                            };
                            temp_adding_delivery_data = {
                                sex: null,
                                name: this.formData.delivery_new.name,
                                phone: this.formData.delivery_new.phone,
                                shipping_info: {
                                    city: this.formData.delivery_new.city?.name,
                                    address: this.formData.delivery_new.address,
                                    district: {
                                        zip: this.formData.delivery_new.district
                                            ?.zip,
                                        name: this.formData.delivery_new
                                            .district?.name,
                                    },
                                },
                            };
                            break;
                    }
                    break;
            }

            let payload = {
                products: temp_selected_products,
                purchaser: temp_purchaser_data,
                delivery: {
                    delivery_method: this.formData.delivery_method,
                    ...temp_delivery_data,
                    time: this.formData.delivery_time,
                    adding: temp_adding_delivery_data,
                },
                bonus: this.formData.bonus,
                comment: this.formData.comment,
            };

            // console.log(payload);

            this.$inertia.post(
                route("shopping_cart"),
                {
                    payload: payload,
                },
                {
                    preserveScroll: (page) =>
                        Object.keys(page.props.errors).length,
                }
            );
        },
    },
};
</script>

<style lang="postcss">
.shopping-cart-increase_button {
    @apply border-none bg-transparent text-black;
}

.shopping-cart-decrease_button {
    @apply border-none bg-transparent text-black;
}

.shopping-cart-trash_button {
    @apply border-none bg-transparent text-black;
}

.shopping-cart-number_input {
    @apply border-none bg-transparent w-14 text-center;
}

/*
.p-datatable {
  @apply my-10;
} */

.p-datatable .p-datatable-header {
    @apply bg-fh-blue text-white;
}

.p-datatable .p-datatable-header {
    @apply bg-fh-blue;
}

.p-datatable .p-datatable-footer {
    @apply px-0;
}

.p-datatable .p-datatable-footer .p-datatable {
    @apply w-full;
}

.p-fieldset-content {
    @apply text-left;
}

.shopping_cart_form_element {
    @apply my-2 pl-4 flex flex-row items-center border-l-4 border-fh-gray-light;
}

.shopping_cart_form_element_no_border {
    @apply my-2 pl-4 flex flex-row items-center;
}

.shopping_cart_form_element .label,
.shopping_cart_form_element_no_border .label {
    @apply w-1/6 mr-2 text-center text-sm;
}

.shopping_cart_form_element .input,
.shopping_cart_form_element_no_border .input {
    @apply text-left w-5/6;
}

.error_information {
    @apply text-red mt-1 pl-1;
}
</style>
